/* Turkish dictionary — the default locale. Flat, dot-separated keys so parity
   with en.ts is a set comparison. Values are the ones frozen in PANEL.md §12;
   the module triples are the transcription of docs/DETECTIONS.md §7. */

import type { Dict } from './index.js'

export const dict: Dict = {
  // ── common ──
  "common.save": "Kaydet",
  "common.cancel": "Vazgeç",
  "common.delete": "Sil",
  "common.edit": "Düzenle",
  "common.add": "Ekle",
  "common.search": "Ara",
  "common.filter": "Filtrele",
  "common.clearFilters": "Filtreleri temizle",
  "common.loadMore": "Daha fazla yükle",
  "common.retry": "Tekrar dene",
  "common.copy": "Kopyala",
  "common.copied": "Kopyalandı",
  "common.confirm": "Onayla",
  "common.close": "Kapat",
  "common.back": "Geri",
  "common.next": "Devam",
  "common.details": "Detay",
  "common.reason": "Sebep",
  "common.never": "Hiç",
  "common.permanent": "Kalıcı",
  "common.all": "Tümü",
  "common.none": "Yok",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.loading": "Yükleniyor…",
  "common.download": "İndir",
  "common.export": "Dışa aktar",
  "common.import": "İçe aktar",
  "common.unsaved": "{n} değişiklik kaydedilmedi",
  "common.noPermission": "Bu işlem için yetkiniz yok",
  "common.permissionDenied": "Bu sayfaya erişiminiz yok",
  "common.serverOffline": "Sunucu çevrimdışı",
  "common.emptyFiltered": "Bu filtrelerle sonuç yok",
  "common.severity.low": "Düşük",
  "common.severity.medium": "Orta",
  "common.severity.high": "Yüksek",
  "common.severity.critical": "Kritik",
  "common.action.log": "Kayıt",
  "common.action.kick": "At",
  "common.action.ban": "Banla",
  "common.action.downgraded": "{from} → {to} (sunucu doğrulamadı)",
  "common.side.client": "İstemci",
  "common.side.server": "Sunucu",
  "common.side.cloud": "Bulut",
  "common.status.never": "Hiç bağlanmadı",
  "common.status.online": "Çevrimiçi",
  "common.status.offline": "Çevrimdışı",
  "common.role.owner": "Sahip",
  "common.role.admin": "Yönetici",
  "common.role.moderator": "Moderatör",
  "common.role.viewer": "İzleyici",
  "common.appName": "SentinelAC",
  "common.optional": "isteğe bağlı",
  "common.required": "zorunlu",
  "common.remove": "Kaldır",
  "common.clear": "Temizle",
  "common.expand": "Genişlet",
  "common.collapse": "Daralt",
  "common.selectPlaceholder": "Seçin…",
  "common.searchPlaceholder": "Ara…",
  "common.noResults": "Sonuç yok",
  "common.errorTitle": "Bir şeyler ters gitti",
  "common.loadedCount": "{n} kayıt yüklendi",
  "common.openMenu": "Menüyü aç",
  "common.userMenu": "Kullanıcı menüsü",
  "common.theme": "Tema",
  "common.themeDark": "Koyu",
  "common.themeLight": "Açık",
  "common.themeSystem": "Sistem",
  "common.language": "Dil",
  "common.locale.tr": "Türkçe",
  "common.locale.en": "English",
  "common.commandPalette": "Komut paleti",
  "common.notFoundTitle": "Sayfa bulunamadı",
  "common.notFoundDesc": "Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.",
  "common.goHome": "Sunucularıma dön",
  "common.skipToContent": "İçeriğe geç",
  "common.requestId": "İstek no",
  "common.step": "Adım {n}/{total}",
  "common.showMore": "Daha fazla göster",
  "common.showLess": "Daha az göster",
  "common.copyFailed": "Kopyalanamadı",
  "common.reveal": "Göster",
  "common.hide": "Gizle",
  "common.typeToConfirm": "Onaylamak için {text} yazın",

  // ── nav ──
  "nav.dashboard": "Panel",
  "nav.live": "Canlı Akış",
  "nav.players": "Oyuncular",
  "nav.detections": "Tespitler",
  "nav.bans": "Banlar",
  "nav.globalBans": "Küresel Banlar",
  "nav.whitelist": "Beyaz Liste",
  "nav.screenshots": "Ekran Görüntüleri",
  "nav.config": "Yapılandırma",
  "nav.commands": "Komutlar",
  "nav.discord": "Discord",
  "nav.team": "Ekip",
  "nav.licenses": "Lisanslar",
  "nav.audit": "Denetim",
  "nav.settings": "Ayarlar",
  "nav.servers": "Sunucular",
  "nav.lookup": "Kimlik Ara",
  "nav.account": "Hesap",
  "nav.apiKeys": "API Anahtarları",
  "nav.adminGlobalBans": "Küresel Ban İncelemesi",
  "nav.logout": "Çıkış",
  "nav.pages": "Sayfalar",
  "nav.groupGeneral": "Genel",
  "nav.groupPlayers": "Oyuncular",
  "nav.groupManage": "Yönetim",
  "nav.sidebar": "Kenar çubuğu",
  "nav.mainNav": "Ana gezinme",

  // ── auth ──
  "auth.loginTitle": "Giriş yap",
  "auth.registerTitle": "Hesap oluştur",
  "auth.forgotTitle": "Şifremi unuttum",
  "auth.resetTitle": "Yeni şifre belirle",
  "auth.inviteTitle": "Davet",
  "auth.email": "E-posta",
  "auth.password": "Şifre",
  "auth.passwordConfirm": "Şifre (tekrar)",
  "auth.displayName": "Görünen ad",
  "auth.currentPassword": "Mevcut şifre",
  "auth.newPassword": "Yeni şifre",
  "auth.login": "Giriş yap",
  "auth.register": "Kayıt ol",
  "auth.forgotLink": "Şifreni mi unuttun?",
  "auth.registerLink": "Hesabın yok mu? Kayıt ol",
  "auth.loginLink": "Girişe dön",
  "auth.passwordRule": "En az 10 karakter",
  "auth.forgotSent": "Bir hesap varsa e-posta gönderildi",
  "auth.resetDone": "Şifreniz güncellendi",
  "auth.sessionsRevoked": "Diğer tüm oturumlar kapatıldı",
  "auth.inviteAccept": "Daveti kabul et",
  "auth.inviteBody": "{server} sunucusuna {role} olarak davet edildiniz",
  "auth.send": "Bağlantı gönder",
  "auth.passwordMismatch": "Şifreler eşleşmiyor",
  "auth.strength": "Şifre gücü",
  "auth.strength.weak": "Zayıf",
  "auth.strength.fair": "Orta",
  "auth.strength.good": "İyi",
  "auth.strength.strong": "Güçlü",
  "auth.registrationClosedTitle": "Kayıtlar kapalı",
  "auth.registrationClosedDesc": "Hesap açmak için bir davet bağlantısına ihtiyacınız var.",
  "auth.lockedUntil": "Hesap {lockedUntil} tarihine kadar kilitli",
  "auth.inviteExpired": "Bu davet geçersiz veya süresi dolmuş",
  "auth.acceptedTitle": "Davet kabul edildi",
  "auth.inviteIntro": "Daveti kabul ettiğinizde sunucu hesabınıza eklenir ve sahibinin seçtiği yetkiyi alırsınız.",
  "auth.forgotIntro": "E-posta adresinizi girin; yeni şifre belirlemeniz için bir bağlantı gönderelim.",
  "auth.resetIntro": "Yeni bir şifre belirleyin. Açık olan tüm oturumlar kapatılacak.",
  "auth.signedInAs": "{email} olarak giriş yapıldı",

  // ── server ──
  "server.title": "Sunucular",
  "server.new": "Yeni sunucu",
  "server.name": "Sunucu adı",
  "server.framework": "Framework",
  "server.timezone": "Saat dilimi",
  "server.emptyTitle": "Henüz sunucunuz yok",
  "server.emptyDesc": "İlk sunucunu oluştur ve lisans anahtarını al",
  "server.playersRatio": "{online}/{max} oyuncu",
  "server.detections24h": "Tespit (24s)",
  "server.bans24h": "Ban (24s)",
  "server.onlineSummary": "Çevrimiçi · {players}/{max} · v{agentVersion} · config v{configVersion}",
  "server.offlineSince": "Çevrimdışı · son sinyal {age}",
  "server.outdated": "Kaynak sürümü eski ({agentVersion} → {minAgentVersion})",
  "server.outdatedBadge": "eski",
  "server.ipLock": "IP kilidi: {ip}",
  "server.resetIp": "IP'yi sıfırla",
  "server.reload": "Yeniden yükle",
  "server.reconnect": "Yeniden bağlan",
  "server.wsOpen": "Canlı",
  "server.wsReconnecting": "Yeniden bağlanıyor…",
  "server.wsClosed": "Bağlantı kesildi",
  "server.wizardStep1": "Sunucu bilgileri",
  "server.wizardStep2": "Lisans anahtarı",
  "server.wizardStep3": "Kurulum",
  "server.keyOnce": "Bu anahtar bir daha gösterilmeyecek",
  "server.keySaved": "Anahtarı kaydettim",
  "server.setrWarning": "Anahtarı mutlaka set ile tanımlayın; setr convar'ı tüm istemcilere kopyalar",
  "server.downloadResource": "Kaynağı indir",
  "server.serverCfg": "server.cfg satırları",
  "server.hardening": "Önerilen güvenlik ayarları",
  "server.waitingHeartbeat": "İlk sinyal bekleniyor…",
  "server.connected": "Sunucu bağlandı!",
  "server.goToPanel": "Panele git",
  "server.switcher": "Sunucu değiştir",
  "server.created": "Sunucu oluşturuldu",
  "server.wizardTitle": "Yeni sunucu oluştur",
  "server.leaveWarning": "Lisans anahtarını kaydetmeden ayrılırsanız bir daha göremezsiniz.",
  "server.installSteps": "Kurulum adımları",
  "server.apiUrl": "API adresi",
  "server.resourceVersion": "Kaynak sürümü",
  "server.nameTaken": "Bu adla bir sunucu zaten var",
  "server.heartbeatHint": "Sunucuyu başlatın; ilk sinyal geldiğinde bu adım kendiliğinden ilerler.",
  "server.framework.standalone": "Bağımsız (framework yok)",
  "server.framework.esx": "ESX",
  "server.framework.qbcore": "QBCore",
  "server.framework.qbox": "Qbox",
  "server.framework.vrp": "vRP",
  "server.copyBlock": "Bu bloğu kopyala",
  "server.wizardCancel": "Vazgeç ve sunucularıma dön",
  "server.keyOnceDesc": "Anahtarı şimdi şifre yöneticinize kaydedin. Bir daha okunamaz; kaybolan anahtar yalnızca yenilenebilir.",
  "server.configSynced": "Config v{version}",

  // ── dashboard ──
  "dashboard.title": "Panel",
  "dashboard.playersOnline": "Çevrimiçi oyuncu",
  "dashboard.detections24h": "Tespit (24s)",
  "dashboard.bans24h": "Ban (24s)",
  "dashboard.bansTotal": "Toplam ban",
  "dashboard.detectionsOverTime": "Zamana göre tespitler",
  "dashboard.playersOverTime": "Zamana göre oyuncular",
  "dashboard.topDetections": "En çok tespit",
  "dashboard.recentBans": "Son banlar",
  "dashboard.recentDetections": "Son tespitler",
  "dashboard.agentHealth": "Kaynak durumu",
  "dashboard.uptime": "Çalışma süresi",
  "dashboard.tickMs": "Tik süresi",
  "dashboard.latency": "Gecikme",
  "dashboard.queueDepth": "Kuyruk",
  "dashboard.noData": "Henüz veri yok",
  "dashboard.range24h": "24 saat",
  "dashboard.range7d": "7 gün",
  "dashboard.range30d": "30 gün",

  // ── detection ──
  "detection.title": "Tespitler",
  "detection.detail": "Tespit detayı",
  "detection.liveTitle": "Canlı akış",
  "detection.occurredAt": "Oluşma",
  "detection.receivedAt": "Ulaşma",
  "detection.serverConfirmed": "Sunucu doğruladı",
  "detection.score": "Kanıt ağırlığı",
  "detection.strikes": "Uyarı sayısı",
  "detection.samples": "Örnekler",
  "detection.evidence": "Kanıt",
  "detection.raw": "Ham veri",
  "detection.coords": "Konum",
  "detection.markFalsePositive": "Yanlış pozitif işaretle",
  "detection.reviewNote": "İnceleme notu",
  "detection.bulkReview": "Seçilenleri incele",
  "detection.pause": "Duraklat",
  "detection.resume": "Devam",
  "detection.autoScroll": "Otomatik kaydır",
  "detection.clear": "Temizle",
  "detection.buffered": "{n} yeni",
  "detection.newRows": "Yeni kayıtlar var",
  "detection.byType": "Türe göre",
  "detection.byAction": "İşleme göre",
  "detection.emptyTitle": "Bu filtrelerle tespit yok",
  "detection.feedEmptyTitle": "Akış boş",
  "detection.feedEmptyDesc": "Modüller yalnızca kayıt modunda olabilir",
  "detection.offlineBanner": "Sunucu çevrimdışı, yeni tespit gelmeyecek",

  // ── player ──
  "player.title": "Oyuncular",
  "player.lookupTitle": "Kimlik ara",
  "player.tabOnline": "Çevrimiçi",
  "player.tabAll": "Tümü",
  "player.tabRecent": "Son ayrılanlar",
  "player.tabDetections": "Tespitler",
  "player.tabBans": "Banlar",
  "player.tabScreenshots": "Ekran görüntüleri",
  "player.tabSessions": "Oturumlar",
  "player.tabOtherServers": "Diğer sunucular",
  "player.trustScore": "Güven puanı",
  "player.playtime": "Oyun süresi",
  "player.joinCount": "Giriş sayısı",
  "player.firstSeen": "İlk görülme",
  "player.lastSeen": "Son görülme",
  "player.notes": "Notlar",
  "player.notesSaved": "Not kaydedildi",
  "player.tokens": "Tokenler ({n})",
  "player.dropReason": "Ayrılma sebebi",
  "player.requestScreenshot": "Ekran görüntüsü iste",
  "player.sendMessage": "Mesaj gönder",
  "player.kick": "At",
  "player.emptyOnline": "Şu anda kimse bağlı değil",
  "player.emptyAll": "Henüz oyuncu kaydı yok",
  "player.lookupPlaceholder": "license:… · discord:… · steam:…",
  "player.lookupEmpty": "Bu kimlik hiçbir sunucunuzda görülmedi",
  "player.lookupMatches": "{n} eşleşme",

  // ── ban ──
  "ban.title": "Banlar",
  "ban.new": "Yeni ban",
  "ban.detail": "Ban detayı",
  "ban.tabActive": "Aktif",
  "ban.tabExpired": "Süresi dolmuş",
  "ban.tabRevoked": "Kaldırılmış",
  "ban.tabGlobal": "Küresel",
  "ban.banCode": "Ban kodu",
  "ban.provisional": "Geçici kod",
  "ban.issuedBy": "Veren",
  "ban.expires": "Bitiş",
  "ban.scope": "Kapsam",
  "ban.target": "Hedef",
  "ban.pasteIdentifiers": "Kimlikleri yapıştır (her satıra bir tane)",
  "ban.duration": "Süre",
  "ban.kickNow": "Oyuncu çevrimiçiyse hemen at",
  "ban.revoke": "Banı kaldır",
  "ban.revokeReason": "Kaldırma sebebi",
  "ban.changeExpiry": "Süreyi değiştir",
  "ban.importTitle": "Ban listesi içe aktar",
  "ban.importResult": "{imported} eklendi, {skipped} atlandı",
  "ban.alreadyBanned": "Bu kimlik zaten banlı",
  "ban.presetCheatMenu": "Cheat menü",
  "ban.presetAimbot": "Aimbot",
  "ban.presetGodmode": "Godmode",
  "ban.presetSpawnAbuse": "Spawn istismarı",
  "ban.presetEvasion": "Ban kaçırma",
  "ban.presetOther": "Diğer",
  "ban.emptyTitle": "Hiç ban yok",
  "ban.globalTitle": "Küresel banlar",
  "ban.globalExplainer": "Küresel liste, katılan sunucuların kesinleşmiş banlarını paylaşır",
  "ban.enforce": "Küresel banları uygula",
  "ban.contribute": "Banlarımı küresel listeye öner",
  "ban.modeBlock": "Engelle",
  "ban.modeFlag": "Sadece işaretle",
  "ban.modeOff": "Kapalı",
  "ban.reputation": "İtibar",
  "ban.eligibility": "Uygunluk",
  "ban.corroborations": "Doğrulama",
  "ban.reporter": "Bildiren",
  "ban.exempt": "Bu sunucuda muaf tut",
  "ban.whyBlocked": "Neden engellendi?",
  "ban.proposeGlobal": "Küresel ban öner",
  "ban.approve": "Onayla",
  "ban.reject": "Reddet",
  "ban.revokeGlobal": "Küresel banı geri al",
  "ban.queueEmpty": "İnceleme kuyruğu boş",
  "ban.global.proposed": "Önerildi",
  "ban.global.approved": "Onaylandı",
  "ban.global.rejected": "Reddedildi",
  "ban.global.revoked": "Geri alındı",
  "ban.global.none": "Yerel",

  // ── whitelist ──
  "whitelist.title": "Beyaz liste",
  "whitelist.add": "Beyaz listeye ekle",
  "whitelist.fromPlayer": "Oyuncudan ekle",
  "whitelist.identifierType": "Kimlik türü",
  "whitelist.identifierValue": "Kimlik değeri",
  "whitelist.label": "Etiket",
  "whitelist.scope": "Kapsam",
  "whitelist.scopeAll": "Tüm modüller",
  "whitelist.scopeModules": "Seçili modüller",
  "whitelist.bypassConnect": "Ban kontrolünü atla",
  "whitelist.bypassConnectOnlyAll": "Ban kontrolü yalnızca tüm modüller seçiliyken atlanabilir",
  "whitelist.expires": "Bitiş",
  "whitelist.aceNote": "ACE izni (sentinel.bypass) ile beyaz liste satırı farklıdır: ACE anlık, beyaz liste kalıcıdır",
  "whitelist.emptyTitle": "Beyaz listede kayıt yok",

  // ── config ──
  "config.title": "Yapılandırma",
  "config.version": "Sürüm",
  "config.lastChange": "Son değişiklik {by} · {time}",
  "config.logOnly": "Yalnızca kayıt modu",
  "config.logOnlyBanner": "Hiçbir modül at/banla uygulamıyor",
  "config.tabModules": "Modüller",
  "config.tabGeneral": "Genel",
  "config.tabConnect": "Bağlantı ve muafiyet",
  "config.tabLists": "Listeler",
  "config.tabEventRules": "Event kuralları",
  "config.eventRules.title": "Event kuralları",
  "config.eventRules.desc": "Kendi sunucunuzun net eventleri üzerine kural yazın: isim eşleşmesi, argüman koşulu ve oyuncu başına hız limiti.",
  "config.eventRules.note": "Her kural kendi işlemini taşır. `Kayıt` ile başlayın, canlı akışta neyi yakaladığını görün, sonra yükseltin. Yalnızca listelediğiniz event adları izlenir; joker karakter yoktur.",
  "config.eventRules.empty": "Henüz kural yok.",
  "config.eventRules.add": "Kural ekle",
  "config.eventRules.newName": "Yeni kural",
  "config.eventRules.remove": "Sil",
  "config.eventRules.enabled": "Etkin",
  "config.eventRules.name": "Kural adı",
  "config.eventRules.events": "Event adları",
  "config.eventRules.mode": "Mod",
  "config.eventRules.modeRate": "Hız limiti — pencerede sayıyı aşınca",
  "config.eventRules.modeMatch": "Eşleşme — ilk gerçekleşmede",
  "config.eventRules.maxPerWindow": "Pencere başına en fazla",
  "config.eventRules.windowSec": "Pencere (sn)",
  "config.eventRules.action": "İşlem",
  "config.eventRules.cancel": "Eventi iptal et",
  "config.eventRules.conditions": "Koşullar — hepsi sağlanmalı",
  "config.eventRules.addCondition": "Koşul ekle",
  "config.eventRules.removeCondition": "Koşulu sil",
  "config.eventRules.arg": "Argüman",
  "config.eventRules.op": "Karşılaştırma",
  "config.eventRules.value": "Değer",
  "config.eventRules.op.equals": "eşittir",
  "config.eventRules.op.notEquals": "eşit değildir",
  "config.eventRules.op.contains": "içerir",
  "config.eventRules.op.gt": "büyüktür",
  "config.eventRules.op.lt": "küçüktür",
  "config.eventRules.op.isType": "tipi",
  "config.eventRules.op.missing": "yok",
  "config.enabled": "Etkin",
  "config.action": "İşlem",
  "config.strikes": "Uyarı eşiği",
  "config.window": "Pencere (sn)",
  "config.screenshot": "Ekran görüntüsü",
  "config.banDuration": "Ban süresi",
  "config.options": "Seçenekler",
  "config.lockedAction": "Bu modül yalnızca kayıt tutar",
  "config.history": "Geçmiş",
  "config.rollback": "Geri al",
  "config.diff": "Farkı gör",
  "config.changeSummary": "Değişiklik özeti",
  "config.saved": "Config v{version} kaydedildi · sunucu 35 sn içinde alacak",
  "config.appliedOk": "Sunucuya uygulandı ✓ v{version}",
  "config.pendingSync": "Config v{applied} → v{current} bekleniyor",
  "config.conflictTitle": "Yapılandırma değişti",
  "config.conflictBody": "{by} v{version} kaydetti",
  "config.conflictRebase": "Yeniden yükle ve değişikliklerimi uygula",
  "config.changedElsewhere": "Başka bir yönetici v{version} kaydetti",
  "config.resetDefaults": "Varsayılanlara dön",
  "config.importTitle": "Yapılandırma içe aktar",
  "config.invalidIssues": "{n} alan geçersiz",
  "config.category.player": "Oyuncu",
  "config.category.weapon": "Silah",
  "config.category.vehicle": "Araç",
  "config.category.combat": "Savaş",
  "config.category.world": "Dünya",
  "config.category.integrity": "Bütünlük",
  "config.category.network": "Ağ",
  "config.category.connection": "Bağlantı",

  // ── screenshot ──
  "screenshot.title": "Ekran görüntüleri",
  "screenshot.pending": "Bekleniyor",
  "screenshot.failed": "Ekran görüntüsü alınamadı ({reason})",
  "screenshot.requested": "Ekran görüntüsü istendi",
  "screenshot.goToDetection": "Tespite git",
  "screenshot.expiresIn": "{time} sonra silinecek",
  "screenshot.signedUrl": "Paylaşılabilir bağlantı",
  "screenshot.emptyTitle": "Henüz ekran görüntüsü yok",
  "screenshot.emptyDesc": "Oyun sunucusunda screenshot-basic kaynağı gerekir",

  // ── command ──
  "command.title": "Komutlar",
  "command.send": "Komut gönder",
  "command.sent": "Komut kuyruğa alındı",
  "command.type": "Tür",
  "command.broadcast": "Herkese",
  "command.message": "Mesaj",
  "command.type.kick": "At",
  "command.type.message": "Mesaj",
  "command.type.screenshot": "Ekran görüntüsü",
  "command.type.reloadConfig": "Yapılandırmayı yenile",
  "command.status.queued": "Sırada",
  "command.status.delivered": "İletildi",
  "command.status.acked": "Uygulandı",
  "command.status.failed": "Başarısız",
  "command.status.expired": "Süresi doldu",
  "command.queueAnyway": "Yine de kuyruğa al",
  "command.emptyTitle": "Henüz komut gönderilmedi",

  // ── discord ──
  "discord.title": "Discord",
  "discord.add": "Webhook ekle",
  "discord.url": "Webhook adresi",
  "discord.events": "Olaylar",
  "discord.minSeverity": "En düşük önem",
  "discord.mentionRole": "Etiketlenecek rol",
  "discord.includeScreenshot": "Ekran görüntüsünü ekle",
  "discord.test": "Test gönder",
  "discord.testOk": "Test mesajı gönderildi",
  "discord.disabled": "Devre dışı: {reason}",
  "discord.reenable": "Yeniden etkinleştir",
  "discord.securityNote": "Webhook adresi yalnızca bulutta saklanır, oyun sunucusuna asla gönderilmez",
  "discord.preview": "Önizleme",
  "discord.emptyTitle": "Webhook tanımlanmamış",

  // ── team ──
  "team.title": "Ekip",
  "team.invite": "Davet et",
  "team.inviteLink": "Davet bağlantısı",
  "team.pending": "Bekleyen davetler",
  "team.transfer": "Sahipliği devret",
  "team.remove": "Çıkar",
  "team.role": "Rol",
  "team.joined": "Katılım",
  "team.cannotChangeOwner": "Sahibin rolü değiştirilemez",
  "team.matrixTitle": "Rol yetkileri",
  "team.emptyInvites": "Bekleyen davet yok",

  // ── license ──
  "license.title": "Lisanslar",
  "license.key": "Anahtar",
  "license.boundIp": "Bağlı IP",
  "license.bindMode": "Bağlama modu",
  "license.bindMode.first_use": "İlk kullanımda bağla",
  "license.bindMode.manual": "Elle",
  "license.bindMode.none": "Bağlama yok",
  "license.bindModeNoneWarning": "Bağlama kapalıyken sunucu en fazla 8 oyuncuyla çalışır",
  "license.rotate": "Anahtarı yenile",
  "license.rotateNote": "Eski anahtar 24 saat daha geçerli",
  "license.revoke": "İptal et",
  "license.resetIp": "IP'yi sıfırla",
  "license.resetIpQuota": "Bugün kalan hak: {n}",
  "license.lastAuth": "Son doğrulama",
  "license.authCount": "Doğrulama sayısı",
  "license.install": "Kurulum",

  // ── audit ──
  "audit.title": "Denetim kaydı",
  "audit.actor": "İşlemi yapan",
  "audit.actionCol": "İşlem",
  "audit.target": "Hedef",
  "audit.before": "Önce",
  "audit.after": "Sonra",
  "audit.exportCsv": "CSV indir",
  "audit.emptyTitle": "Kayıt yok",

  // ── settings ──
  "settings.title": "Ayarlar",
  "settings.general": "Genel",
  "settings.retention": "Saklama süresi",
  "settings.retentionNote": "Bu süreden eski kayıtlar saatlik temizlik işiyle silinir",
  "settings.install": "Kurulum",
  "settings.dangerZone": "Tehlikeli bölge",
  "settings.deleteServer": "Sunucuyu sil",
  "settings.deleteConfirm": "Silmek için sunucu adını yazın",
  "settings.deleteWarning": "Tüm lisanslar iptal edilir ve kaynak korumayı durdurur",
  "settings.account": "Hesap",
  "settings.profile": "Profil",
  "settings.changePassword": "Şifre değiştir",
  "settings.language": "Dil",
  "settings.apiKeys": "API anahtarları",
  "settings.createKey": "Anahtar oluştur",
  "settings.scopes": "Kapsamlar",
  "settings.serverScope": "Sunucu kapsamı",
  "settings.lastUsed": "Son kullanım",
  "settings.keysEmpty": "API anahtarı yok",
  "settings.recentActivity": "Son işlemler",
  "settings.keyCreated": "Anahtar oluşturuldu",
  "settings.allServers": "Tüm sunucular",
  "settings.expiresAt": "Bitiş tarihi",
  "settings.profileSaved": "Profil güncellendi",
  "settings.passwordChanged": "Şifreniz değiştirildi, tekrar giriş yapın",
  "settings.revokeKey": "Anahtarı iptal et",
  "settings.revokeKeyConfirm": "Bu anahtarı kullanan entegrasyonlar hemen çalışmayı durdurur.",
  "settings.keyName": "Anahtar adı",
  "settings.keyIdentifier": "Anahtar",
  "settings.keysEmptyDesc": "Kişisel anahtar, bir botun veya betiğin sunucularınızı API üzerinden okumasını sağlar.",
  "settings.noExpiry": "Süresiz",
  "settings.expiry30d": "30 gün",
  "settings.expiry90d": "90 gün",
  "settings.expiry1y": "1 yıl",
  "settings.emailReadonly": "E-posta adresi değiştirilemez",
  "settings.passwordNote": "Şifrenizi değiştirmek bu oturum dahil tüm oturumları kapatır.",
  "settings.scopesRequired": "En az bir kapsam seçin",
  "settings.scope.servers:read": "Sunucuları oku",
  "settings.scope.detections:read": "Tespitleri oku",
  "settings.scope.players:read": "Oyuncuları ve kimlik aramasını oku",
  "settings.scope.bans:read": "Banları oku",
  "settings.scope.bans:write": "Ban ver ve kaldır",
  "settings.scope.commands:write": "Komut gönder",
  "settings.scope.config:read": "Yapılandırmayı oku",

  // ── errors.<CODE> — one per ERROR_CODES member (SPEC §4.6) ──
  "errors.VALIDATION_ERROR": "Girilen bilgiler geçersiz",
  "errors.AUTH_REQUIRED": "Bu işlem için giriş yapmalısınız",
  "errors.AUTH_INVALID_CREDENTIALS": "E-posta veya şifre hatalı",
  "errors.AUTH_TOKEN_EXPIRED": "Oturumunuzun süresi doldu",
  "errors.AUTH_TOKEN_INVALID": "Oturum bilgisi geçersiz, lütfen tekrar giriş yapın",
  "errors.AUTH_REFRESH_REUSED": "Güvenlik nedeniyle oturum kapatıldı, tekrar giriş yapın",
  "errors.AUTH_LOCKED": "Hesap geçici olarak kilitlendi, {lockedUntil} sonra deneyin",
  "errors.AUTH_REGISTRATION_CLOSED": "Kayıtlar kapalı, davet bağlantısı gerekiyor",
  "errors.FORBIDDEN": "Bu işlem için yetkiniz yok",
  "errors.NOT_FOUND": "Kayıt bulunamadı",
  "errors.CONFLICT": "Bu kayıt zaten mevcut",
  "errors.RATE_LIMITED": "Çok fazla istek, lütfen bekleyin",
  "errors.LICENSE_INVALID": "Lisans anahtarı geçersiz",
  "errors.LICENSE_REVOKED": "Lisans iptal edilmiş",
  "errors.LICENSE_SUSPENDED": "Lisans askıya alınmış",
  "errors.LICENSE_EXPIRED": "Lisans süresi dolmuş",
  "errors.LICENSE_IP_MISMATCH": "Lisans başka bir IP'ye bağlı",
  "errors.AGENT_VERSION_UNSUPPORTED": "Kaynak sürümü çok eski, güncelleyin",
  "errors.AGENT_SIGNATURE_INVALID": "Sunucu imzası doğrulanamadı",
  "errors.HEARTBEAT_SEQ_REPLAY": "Yinelenen sinyal algılandı",
  "errors.BATCH_TOO_LARGE": "Gönderilen veri çok büyük",
  "errors.CONFIG_VERSION_CONFLICT": "Yapılandırma bu sırada değişti",
  "errors.CONFIG_INVALID": "Yapılandırma geçersiz",
  "errors.UPLOAD_TOKEN_INVALID": "Yükleme bağlantısı geçersiz veya kullanılmış",
  "errors.UPLOAD_TOO_LARGE": "Dosya çok büyük (en fazla 5 MB)",
  "errors.UPLOAD_BAD_MIME": "Desteklenmeyen dosya türü",
  "errors.COMMAND_EXPIRED": "Komutun süresi doldu",
  "errors.SERVER_OFFLINE": "Sunucu çevrimdışı, komut gönderilemez",
  "errors.GLOBAL_BAN_NOT_ELIGIBLE": "Bu ban küresel listeye önerilemez",
  "errors.WEBHOOK_INVALID_URL": "Geçerli bir Discord webhook adresi girin",
  "errors.INVITE_INVALID": "Davet geçersiz veya süresi dolmuş",
  "errors.INTERNAL": "Beklenmeyen bir hata oluştu",

  // ── audit.action.<name> — the closed list of SPEC §3.4 ──
  "audit.action.auth.register": "Hesap oluşturuldu",
  "audit.action.auth.login": "Giriş yapıldı",
  "audit.action.auth.login_failed": "Başarısız giriş denemesi",
  "audit.action.auth.locked": "Hesap kilitlendi",
  "audit.action.auth.refresh_reuse": "Oturum jetonu yeniden kullanıldı",
  "audit.action.auth.logout": "Çıkış yapıldı",
  "audit.action.auth.password_change": "Şifre değiştirildi",
  "audit.action.auth.password_reset": "Şifre sıfırlandı",
  "audit.action.apikey.create": "API anahtarı oluşturuldu",
  "audit.action.apikey.revoke": "API anahtarı iptal edildi",
  "audit.action.server.create": "Sunucu oluşturuldu",
  "audit.action.server.update": "Sunucu güncellendi",
  "audit.action.server.delete": "Sunucu silindi",
  "audit.action.server.transfer": "Sunucu sahipliği devredildi",
  "audit.action.member.invite": "Üye davet edildi",
  "audit.action.member.accept": "Davet kabul edildi",
  "audit.action.member.role": "Üye rolü değiştirildi",
  "audit.action.member.remove": "Üye çıkarıldı",
  "audit.action.license.create": "Lisans oluşturuldu",
  "audit.action.license.rotate": "Lisans yenilendi",
  "audit.action.license.revoke": "Lisans iptal edildi",
  "audit.action.license.reset_ip": "Lisans IP sıfırlandı",
  "audit.action.license.bind_ip": "Lisans IP bağlandı",
  "audit.action.license.ip_mismatch": "Lisans IP uyuşmazlığı",
  "audit.action.license.update": "Lisans güncellendi",
  "audit.action.config.update": "Yapılandırma güncellendi",
  "audit.action.config.rollback": "Yapılandırma geri alındı",
  "audit.action.config.import": "Yapılandırma içe aktarıldı",
  "audit.action.config.reset": "Yapılandırma sıfırlandı",
  "audit.action.ban.create": "Ban verildi",
  "audit.action.ban.revoke": "Ban kaldırıldı",
  "audit.action.ban.update": "Ban güncellendi",
  "audit.action.ban.import": "Ban listesi içe aktarıldı",
  "audit.action.ban.propose_global": "Küresel ban önerildi",
  "audit.action.global_ban.review": "Küresel ban incelendi",
  "audit.action.global_ban.override": "Küresel ban muafiyeti",
  "audit.action.whitelist.add": "Beyaz liste kaydı eklendi",
  "audit.action.whitelist.update": "Beyaz liste kaydı güncellendi",
  "audit.action.whitelist.remove": "Beyaz liste kaydı silindi",
  "audit.action.command.create": "Komut gönderildi",
  "audit.action.command.cancel": "Komut iptal edildi",
  "audit.action.webhook.create": "Webhook eklendi",
  "audit.action.webhook.update": "Webhook güncellendi",
  "audit.action.webhook.delete": "Webhook silindi",
  "audit.action.webhook.test": "Webhook test edildi",
  "audit.action.webhook.disabled": "Webhook devre dışı bırakıldı",
  "audit.action.detection.review": "Tespit incelendi",
  "audit.action.player.notes": "Oyuncu notu güncellendi",
  "audit.action.screenshot.delete": "Ekran görüntüsü silindi",
  "audit.action.agent.auth": "Kaynak doğrulandı",
  "audit.action.agent.unlicensed": "Lisanssız kaynak isteği",

  // ── module.<detectionKey>.{name,desc,hint} — one triple per DETECTION_KEYS entry (65) ──
  // Authored once in docs/DETECTIONS.md §7 and transcribed here; i18n.test.ts fails on a missing triple.
  "module.godmode.name": "Tanrı modu",
  "module.godmode.desc": "Oyuncunun hasar almaz duruma geçmesini tespit eder.",
  "module.godmode.hint": "Ölümsüzlük veren yönetici veya \"bayılma\" scriptleriniz SetGodmode export'unu çağırmalı.",
  "module.health_over_max.name": "Maksimum üstü can",
  "module.health_over_max.desc": "Karakterin kendi azami canının üzerine çıkan can değerini tespit eder.",
  "module.health_over_max.hint": "400 can ile oynayan sunucular maxHealthCap seçeneğini yükseltmeli; can veren scriptler SetGodmode export'unu çağırmalı.",
  "module.health_probe.name": "Can sondası (hasar testi)",
  "module.health_probe.desc": "Getter'ı olmayan ölümsüzlük hilelerini küçük bir can testiyle tespit eder.",
  "module.health_probe.hint": "Bayılma ve senaryo gereği ölümsüz durumlarınız SetGodmode export'unu çağırmalı, aksi halde sonda scriptle çakışır.",
  "module.armor_over_max.name": "Maksimum üstü zırh",
  "module.armor_over_max.desc": "Oyuncunun azami zırh değerinin üzerine çıkan zırhı tespit eder.",
  "module.armor_over_max.hint": "Zırh veren scriptleriniz SetGodmode export'unu çağırmalı.",
  "module.invisible.name": "Görünmezlik",
  "module.invisible.desc": "Oyuncunun kendi karakterini görünmez yapmasını tespit eder.",
  "module.invisible.hint": "Görünmezlik kullanan sahne veya yönetici scriptleriniz SetInvisible export'unu çağırmalı.",
  "module.noclip.name": "Noclip (duvardan geçme)",
  "module.noclip.desc": "Çarpışmasız hareketi ve duvardan geçmeyi tespit eder.",
  "module.noclip.hint": "Yönetici noclip araçlarınız SetNoclip export'unu çağırmalı.",
  "module.speed_hack.name": "Hız hilesi",
  "module.speed_hack.desc": "Yaya hâlde motorun izin verdiğinden hızlı hareketi tespit eder.",
  "module.speed_hack.hint": "Hız veren scriptleriniz SetNoclip veya AllowTeleport export'unu çağırmalı.",
  "module.teleport.name": "Işınlanma",
  "module.teleport.desc": "Hiçbir araç veya animasyonun üretemeyeceği konum sıçramasını tespit eder.",
  "module.teleport.hint": "Garaj, asansör ve teleport scriptleriniz AllowTeleport export'unu çağırmalı.",
  "module.spectate.name": "İzleyici modu",
  "module.spectate.desc": "Menülerin kullandığı oyuncu izleme modunu tespit eder.",
  "module.spectate.hint": "İzleme özelliği olan yönetici araçlarınız SetSpectate export'unu çağırmalı.",
  "module.freecam.name": "Serbest kamera",
  "module.freecam.desc": "Kameranın karakterden çok uzakta olduğu serbest kamera kullanımını tespit eder.",
  "module.freecam.hint": "Sinematik ve kamera scriptleriniz AllowScriptCam export'unu çağırmalı.",
  "module.super_jump.name": "Süper zıplama",
  "module.super_jump.desc": "Her karede etkinleştirilen süper zıplamayı tespit eder.",
  "module.super_jump.hint": "Parkur ve süper zıplama scriptleriniz SetNoclip export'unu çağırmalı.",
  "module.infinite_stamina.name": "Sonsuz dayanıklılık",
  "module.infinite_stamina.desc": "Koşarken azalmayan dayanıklılığı tespit eder.",
  "module.infinite_stamina.hint": "Dayanıklılık yenileyen scriptleriniz AllowStamina export'unu çağırmalı.",
  "module.night_vision.name": "Gece görüşü / termal",
  "module.night_vision.desc": "Yetkisiz kaynaktan açılan gece görüşü ve termal görüşü tespit eder.",
  "module.night_vision.hint": "Gece görüşü sunan kaynaklarınızı whitelists.nightVisionResources listesine ekleyin veya AllowNightVision export'unu çağırın.",
  "module.blacklisted_ped.name": "Yasaklı karakter modeli",
  "module.blacklisted_ped.desc": "Yasak listesindeki karakter modellerinin kullanılmasını tespit eder.",
  "module.blacklisted_ped.hint": "Meşru model değişimleri için AllowModel export'unu çağırın veya modeli whitelists.models listesine ekleyin.",
  "module.blacklisted_weapon.name": "Yasaklı silah",
  "module.blacklisted_weapon.desc": "Yasak listesindeki silahların envanterde bulunmasını tespit eder.",
  "module.blacklisted_weapon.hint": "Görev gereği verilen silahlar için AllowWeapon export'unu çağırın.",
  "module.weapon_gained.name": "Açıklanamayan silah kazanımı",
  "module.weapon_gained.desc": "Sunucunun vermediği bir silahın envantere eklenmesini tespit eder.",
  "module.weapon_gained.hint": "Silah veren scriptleriniz AllowWeapon export'unu çağırmalı.",
  "module.infinite_ammo.name": "Sonsuz mermi",
  "module.infinite_ammo.desc": "Ateş edilirken azalmayan mermiyi tespit eder.",
  "module.infinite_ammo.hint": "Sınırsız mermi veren poligon veya görev scriptleriniz SetModuleBypass(src, 'infinite_ammo', saniye) çağırmalı.",
  "module.explosive_ammo.name": "Patlayıcı mermi",
  "module.explosive_ammo.desc": "Normal silahlara patlayıcı veya yakıcı hasar tipi atanmasını tespit eder.",
  "module.explosive_ammo.hint": "Patlayıcı mermi veren scriptleriniz AllowExplosion export'unu çağırmalı.",
  "module.damage_modifier.name": "Hasar çarpanı",
  "module.damage_modifier.desc": "Oyuncunun kendi hasar veya savunma çarpanlarını değiştirmesini tespit eder.",
  "module.damage_modifier.hint": "Hasar çarpanı kullanan scriptleriniz SetModuleBypass(src, 'damage_modifier', saniye) çağırmalı.",
  "module.weapon_damage_meta.name": "Silah hasar meta değişikliği",
  "module.weapon_damage_meta.desc": "Silah hasar değerlerinin oturum başındaki değerden sapmasını tespit eder.",
  "module.weapon_damage_meta.hint": "Hasar değerlerini çalışma anında değiştiren scriptleriniz SetModuleBypass(src, 'weapon_damage_meta', saniye) çağırmalı.",
  "module.silent_aim.name": "Sessiz nişan",
  "module.silent_aim.desc": "Merminin, kameranın baktığı yönden çok uzağa isabet etmesini tespit eder.",
  "module.silent_aim.hint": "Bu bir davranış sezgisidir, kesin kanıt değildir: harici aimbot Lua tarafından görülemez. Sürüş sırasında ateş eden scriptleriniz varsa ignoreInVehicle açık kalsın.",
  "module.shot_cadence.name": "Atış hızı",
  "module.shot_cadence.desc": "Silahın mekanik atış hızından daha hızlı ateş edilmesini tespit eder.",
  "module.shot_cadence.hint": "weapons.meta dosyasını değiştirip atış hızını artırdıysanız o silahları ignoredWeapons listesine ekleyin.",
  "module.no_recoil.name": "Geri tepmesiz atış",
  "module.no_recoil.desc": "Kamerayı hiç sarsmayan atışları tespit eder; geri tepme kaldırılmış demektir.",
  "module.no_recoil.hint": "weapons.meta ile bir silahın geri tepmesini gerçekten kaldırdıysanız o silahı ignoredWeapons listesine ekleyin.",
  "module.magic_bullet.name": "Sihirli mermi",
  "module.magic_bullet.desc": "Tek bir merminin, bir merminin vurabileceğinden fazla oyuncuya hasar verdiğini tespit eder.",
  "module.magic_bullet.hint": "Delip geçen tüfek mermileri için varsayılan sınır 2 kurbandır; patlamalar bu modüle hiç girmez.",
  "module.server_headshot_ratio.name": "Kafa vuruşu oranı",
  "module.server_headshot_ratio.desc": "Sunucu tarafında, oyuncunun isabetlerinin kafaya gelme oranını ölçer.",
  "module.server_headshot_ratio.hint": "Varsayılan olarak yalnızca kayıt tutar. Kendi sunucunuzun ortalamasına bakmadan cezaya yükseltmeyin.",
  "module.weapon_damage_event.name": "Sahte silah hasar olayı",
  "module.weapon_damage_event.desc": "İstemcinin üretemeyeceği silah hasar olaylarını tespit eder.",
  "module.weapon_damage_event.hint": "Özel silah hasarı üreten scriptleriniz AllowWeapon export'unu çağırmalı.",
  "module.give_weapon_event.name": "Silah verme olayı",
  "module.give_weapon_event.desc": "Yasaklı veya sahibi olunmayan karaktere silah verme olaylarını tespit eder.",
  "module.give_weapon_event.hint": "Silah dağıtan scriptleriniz AllowWeapon export'unu çağırmalı.",
  "module.remove_weapon_event.name": "Silah alma olayı",
  "module.remove_weapon_event.desc": "Başkasının karakterinden silah alma olaylarını tespit eder.",
  "module.remove_weapon_event.hint": "Silah toplayan scriptleriniz AllowWeapon veya SetModuleBypass(src, 'remove_weapon_event', saniye) çağırmalı.",
  "module.vehicle_modifier.name": "Araç güç çarpanı",
  "module.vehicle_modifier.desc": "Araca hız, güç veya yerçekimi çarpanı uygulanmasını tespit eder.",
  "module.vehicle_modifier.hint": "Tuning ve yarış scriptleriniz AllowVehicleMod export'unu çağırmalı.",
  "module.vehicle_speed.name": "Araç aşırı hız",
  "module.vehicle_speed.desc": "Aracın kendi azami hızının çok üzerine çıkmasını tespit eder.",
  "module.vehicle_speed.hint": "Nitro ve yarış scriptleriniz AllowVehicleMod export'unu çağırmalı.",
  "module.vehicle_handling.name": "Araç sürüş verisi değişikliği",
  "module.vehicle_handling.desc": "Çalışma anında değiştirilen araç sürüş verilerini tespit eder.",
  "module.vehicle_handling.hint": "Handling düzenleyen tuning scriptleriniz AllowVehicleMod export'unu çağırmalı; export aynı zamanda referansı yeniler.",
  "module.vehicle_godmode.name": "Araç tanrı modu",
  "module.vehicle_godmode.desc": "Darbelere rağmen azami sağlıkta kalan araçları tespit eder.",
  "module.vehicle_godmode.hint": "Tamir ve garaj scriptleriniz AllowVehicleMod export'unu çağırmalı.",
  "module.vehicle_invisible.name": "Görünmez araç",
  "module.vehicle_invisible.desc": "Sürülen aracın görünmez yapılmasını tespit eder.",
  "module.vehicle_invisible.hint": "Alpha ve script görünürlüğü birlikte istenir, bu yüzden spawn sırasındaki solma yanlış pozitif üretmez.",
  "module.vehicle_noclip.name": "Araç noclip",
  "module.vehicle_noclip.desc": "Sürülen araçta çarpışmanın kapatılmasını tespit eder.",
  "module.vehicle_noclip.hint": "Bellek üzerinden yapılan noclip bu bayrağa dokunmaz; onu sunucu taraflı konum kontrolü yakalar.",
  "module.vehicle_gravity.name": "Araç yerçekimi",
  "module.vehicle_gravity.desc": "Araç yerçekiminin ayarlanan varsayılandan sapmasını tespit eder.",
  "module.vehicle_gravity.hint": "Düşük yerçekimi etkinliği yapıyorsanız modülü kapatmak yerine defaultGravity değerini kendi sayınıza çekin.",
  "module.player_blips.name": "Oyuncu blipleri (ESP)",
  "module.player_blips.desc": "Kayıtlı hiçbir kaynağın oluşturmadığı oyuncu bliplerini tespit eder.",
  "module.player_blips.hint": "Blip oluşturan scriptleriniz istemci tarafında RegisterBlip export'unu çağırmalı veya blip whitelists.blipSprites listesine eklenmeli.",
  "module.entity_spam_client.name": "İstemci taraflı nesne spam'i",
  "module.entity_spam_client.desc": "Oyuncunun çevresinde ani nesne oluşturma patlamalarını istemci tarafında tespit eder.",
  "module.entity_spam_client.hint": "Toplu nesne oluşturan scriptleriniz AllowEntitySpawn export'unu çağırmalı.",
  "module.menu_texture.name": "Hile menüsü dokusu",
  "module.menu_texture.desc": "Hile menülerinin yüklediği doku sözlüklerini tespit eder.",
  "module.menu_texture.hint": "Kendi arayüz dokularınızı whitelists.textures listesine ekleyin.",
  "module.menu_key.name": "Hile menüsü tuşu",
  "module.menu_key.desc": "Hile menülerinin açılış tuşlarına basılmasını yalnızca kayıt amacıyla izler.",
  "module.menu_key.hint": "Bu modül hiçbir zaman ceza uygulamaz; yanlış pozitif için IgnorePlayer export'unu kullanın.",
  "module.resource_injection.name": "Kaynak enjeksiyonu",
  "module.resource_injection.desc": "Sunucunun başlatmadığı bir kaynağın istemcide çalışmasını tespit eder.",
  "module.resource_injection.hint": "Meşru istemci kaynaklarınızı whitelists.resources listesine ekleyin.",
  "module.resource_stopped.name": "Anticheat durduruldu",
  "module.resource_stopped.desc": "SentinelAC istemci scriptinin durdurulmasını veya engellenmesini tespit eder.",
  "module.resource_stopped.hint": "Test istemcileri için IgnorePlayer export'unu kullanın; başka bypass yoktur.",
  "module.client_integrity.name": "İstemci dosya bütünlüğü",
  "module.client_integrity.desc": "İstemcideki SentinelAC dosyalarının sunucudakiyle uyuşmamasını tespit eder.",
  "module.client_integrity.hint": "Yalnızca kayıt tutar; bilinen bir test istemcisi için IgnorePlayer export'unu kullanın.",
  "module.client_honeypot.name": "İstemci bal küpü",
  "module.client_honeypot.desc": "İstemci tarafındaki tuzak olay, export ve komutların tetiklenmesini tespit eder.",
  "module.client_honeypot.hint": "Tasarım gereği bypass yoktur; yalnızca personel ACE izni ve IgnorePlayer export'u muaf tutar.",
  "module.heartbeat_missing.name": "Kalp atışı yanıtsız",
  "module.heartbeat_missing.desc": "Bağlı olduğu hâlde anticheat sorgusuna yanıt vermeyen istemcileri tespit eder.",
  "module.heartbeat_missing.hint": "Ağır yüklü test istemcileri için SetModuleBypass(src, 'heartbeat_missing', saniye) çağırın.",
  "module.honeypot_event.name": "Sunucu bal küpü olayı",
  "module.honeypot_event.desc": "Yalnızca sunucuda kayıtlı tuzak olayların tetiklenmesini tespit eder.",
  "module.honeypot_event.hint": "Tasarım gereği bypass yoktur; bu isimler hiçbir istemciye gönderilmez.",
  "module.honeypot_export.name": "Sunucu bal küpü export'u",
  "module.honeypot_export.desc": "Bir kaynağın anticheat'i kapatmaya çalışan tuzak export'ları çağırmasını tespit eder.",
  "module.honeypot_export.hint": "Tasarım gereği bypass yoktur; bu tetiklendiğinde ilgili kaynağı inceleyin.",
  "module.honeypot_command.name": "Sunucu bal küpü komutu",
  "module.honeypot_command.desc": "Anticheat'i kapatmayı vaat eden tuzak komutların çalıştırılmasını tespit eder.",
  "module.honeypot_command.hint": "Tasarım gereği bypass yoktur; yalnızca personel ACE izni muaf tutar.",
  "module.explosion_spam.name": "Patlama spam'i",
  "module.explosion_spam.desc": "Hiçbir meşru silahın üretemeyeceği sıklıkta patlamayı tespit eder.",
  "module.explosion_spam.hint": "Patlama üreten görev ve efekt scriptleriniz AllowExplosion export'unu çağırmalı.",
  "module.explosion_blacklist.name": "Yasaklı patlama türü",
  "module.explosion_blacklist.desc": "Yasak listesindeki patlama türlerinin oluşturulmasını tespit eder.",
  "module.explosion_blacklist.hint": "Meşru patlama üreten scriptleriniz AllowExplosion export'unu çağırmalı.",
  "module.fire_spam.name": "Yangın spam'i",
  "module.fire_spam.desc": "Toplu yangın oluşturmayı tespit eder.",
  "module.fire_spam.hint": "İtfaiye ve yangın senaryosu scriptleriniz AllowExplosion export'unu çağırmalı.",
  "module.clear_ped_tasks.name": "Görev temizleme istismarı",
  "module.clear_ped_tasks.desc": "Başka bir oyuncunun animasyonlarını iptal eden görev temizleme olaylarını tespit eder.",
  "module.clear_ped_tasks.hint": "Oyuncu görevlerini temizleyen scriptleriniz SetModuleBypass(src, 'clear_ped_tasks', saniye) çağırmalı.",
  "module.projectile_spam.name": "Mermi/roket spam'i",
  "module.projectile_spam.desc": "İmkânsız hızda mermi ve roket fırlatmayı tespit eder.",
  "module.projectile_spam.hint": "Havai fişek ve patlayıcı scriptleriniz AllowExplosion export'unu çağırmalı.",
  "module.ptfx_blacklist.name": "Yasaklı partikül efekti",
  "module.ptfx_blacklist.desc": "Yasak listesindeki partikül sözlüklerinden efekt oluşturulmasını tespit eder.",
  "module.ptfx_blacklist.hint": "Bu efektleri kullanan scriptleriniz SetModuleBypass(src, 'ptfx_blacklist', saniye) çağırmalı.",
  "module.entity_spawn_rate.name": "Nesne oluşturma hızı",
  "module.entity_spawn_rate.desc": "Bir oyuncunun meşru hiçbir akışın gerektirmeyeceği hızda nesne oluşturmasını tespit eder.",
  "module.entity_spawn_rate.hint": "Toplu spawn yapan scriptleriniz AllowEntitySpawn export'unu çağırmalı.",
  "module.entity_blacklisted_model.name": "Yasaklı nesne modeli",
  "module.entity_blacklisted_model.desc": "Yasak listesindeki araç, karakter veya nesne modellerinin oluşturulmasını tespit eder.",
  "module.entity_blacklisted_model.hint": "Meşru kullanım için AllowModel export'unu çağırın veya modeli whitelists.models listesine ekleyin.",
  "module.entity_unauthorized_script.name": "Yetkisiz kaynaktan nesne",
  "module.entity_unauthorized_script.desc": "Beyaz listede olmayan bir scriptin ağ nesnesi oluşturmasını tespit eder.",
  "module.entity_unauthorized_script.hint": "Kendi spawner kaynaklarınızı whitelists.entityScripts listesine ekleyin.",
  "module.server_godmode.name": "Sunucu doğrulamalı tanrı modu",
  "module.server_godmode.desc": "Sunucunun kendi ölçümüyle doğrulanan ölümsüzlüğü tespit eder.",
  "module.server_godmode.hint": "Bayılma ve senaryo gereği ölümsüz durumlarınız mutlaka SetGodmode export'unu çağırmalı.",
  "module.server_super_jump.name": "Sunucu doğrulamalı süper zıplama",
  "module.server_super_jump.desc": "Sunucunun kendi okumasıyla doğrulanan süper zıplamayı tespit eder.",
  "module.server_super_jump.hint": "Parkur scriptleriniz SetNoclip export'unu çağırmalı.",
  "module.server_freecam.name": "Sunucu doğrulamalı serbest kamera",
  "module.server_freecam.desc": "Sunucunun kendi görüşüne göre karakterden uzaklaşan kamerayı tespit eder.",
  "module.server_freecam.hint": "Sinematik scriptleriniz AllowScriptCam export'unu çağırmalı.",
  "module.server_teleport.name": "Sunucu doğrulamalı ışınlanma",
  "module.server_teleport.desc": "Sunucunun kendi kopyasından ölçülen imkânsız konum sıçramasını tespit eder.",
  "module.server_teleport.hint": "Garaj, asansör ve teleport scriptleriniz AllowTeleport export'unu çağırmalı.",
  "module.server_speed.name": "Sunucu doğrulamalı hız hilesi",
  "module.server_speed.desc": "Sunucudan ölçülen, motorun tavanını aşan yaya hızını tespit eder.",
  "module.server_speed.hint": "Hız veren scriptleriniz SetNoclip veya AllowTeleport export'unu çağırmalı.",
  "module.chat_spam.name": "Sohbet spam'i",
  "module.chat_spam.desc": "Sohbette aşırı sık veya aşırı uzun mesaj gönderimini tespit eder.",
  "module.chat_spam.hint": "Otomatik duyuru botlarınız SetModuleBypass(src, 'chat_spam', saniye) çağırmalı.",
  "module.chat_blacklisted_string.name": "Sohbette yasaklı ifade",
  "module.chat_blacklisted_string.desc": "Sohbette hile menüsü reklamı geçen mesajları tespit eder.",
  "module.chat_blacklisted_string.hint": "Yanlış eşleşen bir terimi blacklists.chatStrings listesinden çıkarın.",
  "module.event_spam.name": "Olay spam'i",
  "module.event_spam.desc": "Bir istemcinin sunucu olaylarını meşru hızın çok üzerinde tetiklemesini tespit eder.",
  "module.event_spam.hint": "Yoğun kullanılan olaylarınız için RegisterProtectedEvent ile daha yüksek limit tanımlayın.",
  "module.blacklisted_event.name": "Yasaklı olay tetikleme",
  "module.blacklisted_event.desc": "Yalnızca hile menülerinin kullandığı olayların tetiklenmesini tespit eder.",
  "module.blacklisted_event.hint": "Kendi kaynaklarınızla çakışan bir adı blacklists.events listesinden çıkarın.",
  "module.safe_event_invalid.name": "Geçersiz güvenli olay tokeni",
  "module.safe_event_invalid.desc": "Kayıtlı bir güvenli olayın geçerli token olmadan gelmesini tespit eder.",
  "module.safe_event_invalid.hint": "Güvenli olayları yalnızca SentinelAC istemci export'u ile tetikleyin.",
  "module.event_rule.name": "Event kuralı",
  "module.event_rule.desc": "Kendi yazdığınız event kurallarının ihlallerini bildirir.",
  "module.event_rule.hint": "Kuralların kendisi Yapılandırma > Event kuralları sekmesinde. Her kural kendi işlemini taşır; bu modül sadece açma/kapama anahtarı ve strike penceresidir.",
  "module.resource_list_mismatch.name": "Kaynak listesi uyuşmazlığı",
  "module.resource_list_mismatch.desc": "İstemcinin bildirdiği kaynak listesinin sunucununkiyle uyuşmamasını tespit eder.",
  "module.resource_list_mismatch.hint": "İstemcide isteğe bağlı yüklenen kaynaklarınızı whitelists.resources listesine ekleyin.",
  "module.connect_offline.name": "Çevrimdışı bağlantı doğrulaması",
  "module.connect_offline.desc": "Bulut ulaşılamazken yerel ban kopyasıyla kabul edilen bağlantıları kaydeder.",
  "module.connect_offline.hint": "Bu bir suçlama değildir; hiçbir işlem uygulanmaz, yalnızca denetim için kaydedilir.",
  "module.custom.name": "Özel tespit",
  "module.custom.desc": "Sunucu sahibinin kendi kaynaklarının Report export'u ile bildirdiği olayları taşır.",
  "module.custom.hint": "Anlamını çağıran script belirler; gürültülü bir çağrı için SetModuleBypass(src, 'custom', saniye) kullanın.",
  "module.connect_ban_evasion.name": "Ban kaçırma girişimi",
  "module.connect_ban_evasion.desc": "Donanım tokenleri aktif bir banla eşleşen, kimlikleri farklı oyuncuları tespit eder.",
  "module.connect_ban_evasion.hint": "Aynı bilgisayarı paylaşan oyuncular için bypass_connect işaretli bir beyaz liste satırı ekleyin.",
  "module.connect_missing_identifier.name": "Eksik kimlik",
  "module.connect_missing_identifier.desc": "Zorunlu kimlik türlerinden birini sunmayan bağlantıları tespit eder.",
  "module.connect_missing_identifier.hint": "İstisna tanımak için ilgili oyuncuya bir beyaz liste satırı ekleyin.",
  "module.connect_vpn.name": "VPN / proxy bağlantısı",
  "module.connect_vpn.desc": "VPN, proxy veya barındırma sağlayıcısına ait IP'lerden gelen bağlantıları tespit eder.",
  "module.connect_vpn.hint": "Meşru VPN kullanan oyuncular için bypass_connect işaretli bir beyaz liste satırı ekleyin.",
  "module.connect_name_filter.name": "Yasaklı oyuncu adı",
  "module.connect_name_filter.desc": "Yasaklı kalıplara uyan veya aşırı uzun oyuncu adlarını tespit eder.",
  "module.connect_name_filter.hint": "Fazla geniş bir kalıbı connect.nameBlacklistPatterns listesinden çıkarın.",
  "module.connect_low_trust.name": "Düşük güven puanı",
  "module.connect_low_trust.desc": "Güven puanı eşiğin altında olan oyuncuların bağlanmasını yakalar.",
  "module.connect_low_trust.hint": "Varsayılan `Kayıt` gölge moddur: eşiği kurun, kimin eleneceğini canlı akışta görün, sonra `At`a yükseltin.",

  // ── staff pages: bans, global bans, whitelist, screenshots, commands ──
  "common.from": "Başlangıç",
  "common.to": "Bitiş",
  "common.statusLabel": "Durum",
  "ban.newDesc": "Hedefi seçin ya da kimlikleri yapıştırın; ban oluşmadan önce anlaşılanlar gösterilir.",
  "ban.targetPlayer": "Oyuncu seç",
  "ban.targetIdentifiers": "Kimlik yapıştır",
  "ban.targetRequired": "Bir oyuncu seçin",
  "ban.targetPlayerUnnamed": "adsız oyuncu",
  "ban.needHardIdentifier": "En az bir kalıcı kimlik gerekir: license, license2, steam, discord veya fivem",
  "ban.parsedTitle": "Anlaşılan kimlikler",
  "ban.parsedEmpty": "Henüz geçerli kimlik yok",
  "ban.parsedInvalid": "{n} satır anlaşılamadı: {lines}",
  "ban.playerNameLabel": "Oyuncu adı",
  "ban.reasonRequired": "Sebep zorunlu",
  "ban.proposeGlobalDesc": "Onaylanırsa bu ban, küresel listeyi uygulayan tüm sunucularda geçerli olur.",
  "ban.proposeGlobalNeedsEvidence": "Öneri için ekran görüntüsü ya da kesin sonuç veren bir modül gerekir",
  "ban.confirmTitle": "Banı onaylayın",
  "ban.confirmKick": "Oyuncu çevrimiçiyse hemen sunucudan atılacak.",
  "ban.confirmGlobal": "Bu ban küresel listeye önerilecek.",
  "ban.created": "Ban oluşturuldu ({code})",
  "ban.durationDaysValue": "{n} gün",
  "ban.emptyDesc": "Bu sunucuda henüz ban kaydı yok.",
  "ban.searchPlaceholder": "Oyuncu adı ya da ban kodu",
  "ban.sourceLabel": "Kaynak",
  "ban.source.system": "Sistem",
  "ban.source.panel": "Panel",
  "ban.source.export": "Dışa aktarım",
  "ban.source.command": "Komut",
  "ban.source.import": "İçe aktarım",
  "ban.source.evasion": "Ban kaçırma",
  "ban.importDesc": "txAdmin ya da SentinelAC dışa aktarımını buraya yapıştırın.",
  "ban.importFormat": "Biçim",
  "ban.importFormat.txadmin": "txAdmin",
  "ban.importFormat.sentinelac": "SentinelAC",
  "ban.importFormat.json": "JSON",
  "ban.importData": "Veri",
  "ban.importDataHint": "En fazla 20.000 kayıt, 1 MiB.",
  "ban.importResultTitle": "İçe aktarma sonucu",
  "ban.identifiersTitle": "Kimlikler",
  "ban.identifierHard": "Kalıcı",
  "ban.identifierSoft": "Geçici",
  "ban.identifierInactive": "Pasif",
  "ban.notActive": "Ban artık aktif değil",
  "ban.alreadyProposed": "Bu ban zaten küresel listeye önerilmiş",
  "ban.revokeConfirm": "{code} kodlu ban kaldırılacak — oyuncu: {player}. Oyuncu yeniden bağlanabilecek.",
  "ban.revoked": "Ban kaldırıldı ({code})",
  "ban.changeExpiryConfirm": "{code} kodlu banın bitiş tarihi değişecek.",
  "ban.changeExpiryHint": "Boş bırakılırsa ban kalıcı olur.",
  "ban.reporterAnonymised": "Bildiren sunucu her zaman anonimdir.",
  "ban.maskedHint": "Kimlik maskelenmiş olarak geldi",
  "ban.maskedNote": "Küresel liste kimlikleri maskelenmiş gelir. Tam değerleri yalnızca platform yöneticisi ve öneren sunucunun sahibi görebilir.",
  "ban.eligibility.contribution_disabled": "Katkı açık olmalı",
  "ban.eligibility.server_too_new": "Sunucu en az 7 günlük olmalı",
  "ban.eligibility.reputation_below_40": "İtibar en az 40 olmalı",
  "ban.eligibility.no_evidence": "Ekran görüntüsü ya da kesin sonuç veren bir modül olmalı",
  "ban.enforceHint": "Uygulama biçimi yapılandırma geçmişine yazılır.",
  "ban.contributeHint": "Kendi banlarınızı küresel listeye önerebilirsiniz.",
  "ban.mode.block": "Engelle",
  "ban.mode.flag": "Sadece işaretle",
  "ban.mode.off": "Kapalı",
  "ban.whyBlockedHint": "Yalnızca kalıcı kimlikler küresel eşleşir; ip ve token eşleşmez.",
  "ban.whyBlockedNoMatch": "Bu kimlik küresel listede yok.",
  "ban.globalEmptyTitle": "Küresel listede kayıt yok",
  "ban.globalEmptyDesc": "Şu anda onaylanmış küresel ban bulunmuyor.",
  "ban.exemptConfirm": "{code} kodlu küresel ban bu sunucuda uygulanmayacak. Sebep: {reason}",
  "ban.exemptDone": "Muafiyet eklendi ({code})",
  "ban.queueEmptyDesc": "İncelenmeyi bekleyen öneri yok.",
  "ban.reviewNote": "İnceleme notu",
  "ban.reviewConfirm": "{code} kodlu öneri — sebep: {reason}, bildiren: {proposer}",
  "ban.reviewReputationNote": "Onay bildiren sunucuya +2, ret −10 itibar getirir.",
  "ban.reputationPlus": "Bildiren sunucuya +2 itibar",
  "ban.reputationMinus": "Bildiren sunucuya −10 itibar",
  "whitelist.emptyDesc": "Hiçbir oyuncu muaf tutulmuyor.",
  "whitelist.editTitle": "Beyaz liste satırını düzenle",
  "whitelist.dialogDesc": "Kimlik ve kapsam seçin. Kapsam tüm modüller ise oyuncu her kontrolden muaf olur.",
  "whitelist.valueRequired": "Kimlik değeri zorunlu",
  "whitelist.modulesRequired": "En az bir modül seçin",
  "whitelist.labelHint": "Bu satırın neden var olduğunu yazın.",
  "whitelist.bypassConnectDesc": "Yalnızca kapsam tüm modüller olduğunda etkilidir; küresel banlar dahil bağlantı kontrolü atlanır.",
  "whitelist.fullBypassTitle": "Tam muafiyet",
  "whitelist.fullBypassDesc": "Bu satır her modülü susturur ve bağlantıdaki ban kontrolünü atlar. Yalnızca gerçekten güvendiğiniz kimlikler için kullanın.",
  "whitelist.expiresHint": "Boş bırakılırsa satır kalıcı olur.",
  "whitelist.scopeAllWarning": "Tüm modüller seçili: bu kimlik hiçbir kontrole takılmaz.",
  "whitelist.scopeModulesHint": "{n} modül seçildi. Diğer modüller çalışmaya devam eder.",
  "whitelist.scopeModulesCount": "{n} modül",
  "whitelist.scopeRuleTitle": "Kapsam kuralı",
  "whitelist.scopeRuleDesc": "Tüm modüller kapsamı her kontrolü susturur; seçili modüller kapsamı yalnızca o modülleri susturur ve bağlantı kontrolünü asla atlamaz.",
  "whitelist.conflictTitle": "Bu kimlik zaten listede",
  "whitelist.conflictDesc": "Aynı kimlik için ikinci satır oluşturulamaz; mevcut satırı düzenleyin.",
  "whitelist.conflictRow": "Mevcut satır: {value}",
  "whitelist.added": "Beyaz listeye eklendi ({value})",
  "whitelist.removeTitle": "Beyaz liste satırını sil",
  "whitelist.removeConfirm": "{value} satırı silinecek. Mevcut kapsam: {scope}.",
  "whitelist.removed": "Satır silindi ({value})",
  "whitelist.fromPlayerDesc": "Oyuncunun her kalıcı kimliği için bir satır oluşturulur.",
  "whitelist.fromPlayerResult": "{created} satır eklendi, {skipped} atlandı",
  "whitelist.skippedOther": "Eklenemedi",
  "screenshot.status.pending": "Bekleniyor",
  "screenshot.status.uploaded": "Yüklendi",
  "screenshot.status.failed": "Başarısız",
  "screenshot.status.expired": "Süresi doldu",
  "screenshot.dimensions": "Çözünürlük",
  "screenshot.mime": "Tür",
  "screenshot.signedUrlCopied": "Paylaşılabilir bağlantı kopyalandı",
  "screenshot.requestDesc": "Çevrimiçi bir oyuncudan yeni bir kare istenir.",
  "screenshot.requestTarget": "Hedef: {player} · #{source}",
  "screenshot.cooldown": "Bekleme süresi: {seconds} sn",
  "screenshot.evidenceOnly": "Ekran görüntüsü yalnızca kanıttır: eksik bir kare suç kanıtı değildir.",
  "screenshot.deleteTitle": "Ekran görüntüsünü sil",
  "screenshot.deleteConfirm": "{player} oyuncusunun {at} tarihli ekran görüntüsü kalıcı olarak silinecek.",
  "screenshot.deleted": "Ekran görüntüsü silindi",
  "command.type.ban": "Ban",
  "command.type.unban": "Ban kaldır",
  "command.playerOffline": "Çevrimdışı",
  "command.payload": "İçerik",
  "command.attempts": "Deneme",
  "command.result": "Sonuç",
  "command.audience": "Alıcı",
  "command.banHint": "Ban ve ban kaldırma buradan gönderilmez; tek yol banlar sayfasıdır:",
  "command.incomplete": "Önce hedefi ve metni doldurun",
  "command.broadcastWarning": "Mesaj sunucudaki herkese gidecek.",
  "command.cancelTitle": "Komutu iptal et",
  "command.cancelConfirm": "Sıradaki {type} komutu iptal edilecek: {target}",
  "command.cancelled": "Komut iptal edildi",
  "command.cancelTooLate": "Komut çoktan iletilmiş, iptal edilemedi",
  "command.emptyDesc": "Bu sunucuya henüz komut gönderilmedi.",

  // ── owner administration: config editor, discord, team, licenses, audit, settings ──
  "common.selectAll": "Tümünü seç",
  "common.selectRow": "Satırı seç",
  "common.removeItem": "{item} kaldır",
  "common.tagPlaceholder": "Yazın ve Enter’a basın",
  "common.itemCount": "{n} kayıt",
  "common.itemCountMax": "{n}/{max}",
  "common.maxItems": "En fazla {n} kayıt eklenebilir",
  "common.numberOnly": "Yalnızca sayı girilebilir",
  "common.unitSecond": "sn",
  "common.unitHour": "sa",
  "common.unitDay": "gün",
  "common.durationDays": "{n} gün",
  "common.durationHours": "{n} saat",
  "config.field": "Alan",
  "config.noChanges": "Değişiklik yok",
  "config.diffOnlyChanged": "Yalnızca değişen alanlar gösteriliyor",
  "config.diffCurrent": "Kayıtlı",
  "config.diffDraft": "Taslak",
  "config.currentVersion": "güncel",
  "config.systemAuthor": "Sistem",
  "config.searchPlaceholder": "Modül ara",
  "config.groupCount": "{enabled}/{total} etkin",
  "config.logOnlyDesc": "Açıkken hiçbir modül at veya banla uygulamaz; hepsi yalnızca kayıt tutar.",
  "config.logOnlySuffix": "→ kayıt",
  "config.deterministic": "Kesin sinyal",
  "config.deterministicHint": "Meşru bir yol bu sinyali üretmez, bu yüzden küresel ban önerisine uygundur.",
  "config.serverVerifiable": "Sunucu doğrulayabilir",
  "config.serverVerifiableHint": "Sunucu iddiayı doğrulayamazsa ban, ata düşürülür.",
  "config.noOptions": "Bu modülün ayarı yok",
  "config.optionsHint": "Alan adları modülün kendi şema adlarıdır ve çevrilmez.",
  "config.rangeHint": "{min} – {max}",
  "config.minHint": "en az {min}",
  "config.maxHint": "en fazla {max}",
  "config.preview": "Önizleme",
  "config.insertPlaceholder": "Yer tutucu ekle:",
  "config.honeypotNote": "Sunucu bal küpü adları istemcilere asla gönderilmez; istemci listesi ise oyun paketinde bulunur.",
  "config.vpnPrivacyNotice": "Bu ayar, katılan oyuncunun IP adresini üçüncü taraf bir servise gönderir (KVKK/GDPR).",
  "config.historyEmpty": "Sürüm geçmişi boş",
  "config.alreadyCurrent": "Bu sürüm zaten güncel",
  "config.rollbackWarning": "v{version} içeriğiyle YENİ bir sürüm oluşturulur; geçmişten hiçbir şey silinmez.",
  "config.resetWarning": "{n} alan varsayılana dönecek.",
  "config.changedElsewhereDesc": "Taslağınız korundu. Değişikliklerinizi yeni sürümün üzerine uygulayabilirsiniz.",
  "config.conflictTheirs": "Diğer yöneticinin değişikliği",
  "config.conflictMine": "Sizin değişikliğiniz",
  "config.conflictLeaves": "{n} alanı iki taraf da değiştirdi",
  "config.conflictKeepMine": "Benimki: {mine} · diğeri: {theirs}",
  "config.importDrop": "JSON dosyasını buraya sürükleyin",
  "config.importChooseFile": "Dosya seç",
  "config.importPaste": "veya JSON yapıştırın",
  "config.importNotJson": "Geçerli bir JSON değil",
  "config.importNothing": "Önce geçerli bir yapılandırma yükleyin",
  "config.sectionGeneral": "Genel",
  "config.sectionMessages": "Oyuncuya gösterilen mesajlar",
  "config.sectionTiming": "Zamanlama",
  "config.sectionTimingDesc": "Oyuncu spawn olduktan sonra modüllerin ne zaman rapor etmeye başlayacağını belirler.",
  "config.sectionReportLimit": "Rapor hız sınırı",
  "config.sectionReportLimitDesc": "Bir istemcinin pencere başına gönderebileceği en fazla rapor sayısı.",
  "config.sectionOffline": "Bulut erişilemezse",
  "config.sectionOfflineDesc": "Oyuncu bağlanırken bulut yanıt vermezse ne yapılacağı.",
  "config.sectionIdentity": "Kimlik ve isim",
  "config.sectionEnforcement": "Uygulama",
  "config.sectionConnectMessages": "Bağlantı mesajları",
  "config.sectionBypass": "Yetkili muafiyeti",
  "config.sectionBypassDesc": "Bu ACE izinlerine sahip yetkililer her modülden muaftır.",
  "config.sectionSafeEvents": "Güvenli olaylar",
  "config.sectionSafeEventsDesc": "Kaynak olayları tek kullanımlık token ile imzalanır.",
  "config.sectionScreenshots": "Ekran görüntüleri",
  "config.sectionBlacklists": "Kara listeler",
  "config.sectionBlacklistsDesc": "Bu listedekiler yasaktır.",
  "config.sectionWhitelists": "Beyaz listeler",
  "config.sectionWhitelistsDesc": "Bu listedekiler ilgili kontrollerden muaf tutulur.",
  "config.sectionHoneypots": "Bal küpleri",
  "config.offlinePolicy.cache": "Önbelleği kullan",
  "config.offlinePolicy.cacheDesc": "Son bilinen ban listesiyle karar verilir; liste eskiyse yeni banlar kaçabilir.",
  "config.offlinePolicy.allow": "Herkesi al",
  "config.offlinePolicy.allowDesc": "Bulut erişilemezken banlı oyuncular da sunucuya girebilir.",
  "config.offlinePolicy.deny": "Kimseyi alma",
  "config.offlinePolicy.denyDesc": "Bulut erişilemezken hiç kimse sunucuya giremez.",
  "config.field.general.framework": "Framework",
  "config.field.general.debug": "Hata ayıklama",
  "config.field.general.debugDesc": "Kaynak, sunucu konsoluna ayrıntılı kayıt yazar.",
  "config.field.general.txAdminAdminsBypass": "txAdmin yöneticileri muaf",
  "config.field.general.txAdminAdminsBypassDesc": "txAdmin’de yetkili olan herkes her modülden muaf tutulur.",
  "config.field.general.mirrorTxAdminBans": "txAdmin banlarını yansıt",
  "config.field.general.mirrorTxAdminBansDesc": "txAdmin üzerinden verilen banlar SentinelAC kayıtlarına da işlenir.",
  "config.field.general.banMessage": "Ban mesajı",
  "config.field.general.kickMessage": "At mesajı",
  "config.field.general.appealUrl": "İtiraz adresi",
  "config.field.general.appealUrlHint": "{appealUrl} yer tutucusunda kullanılır.",
  "config.field.general.spawnGraceMs": "Spawn sonrası bekleme",
  "config.field.general.frameworkGraceMs": "Framework beklemesi",
  "config.field.general.readySettleMs": "Hazır olma beklemesi",
  "config.field.general.clientHeartbeatIntervalMs": "İstemci sinyal aralığı",
  "config.field.general.clientHeartbeatMissLimit": "Kaçırılabilir sinyal sayısı",
  "config.field.general.reportRateLimit.max": "Pencere başına rapor",
  "config.field.general.reportRateLimit.windowMs": "Pencere",
  "config.field.connect.offlinePolicy": "Bulut erişilemezse",
  "config.field.connect.timeoutMs": "Bulut zaman aşımı",
  "config.field.connect.requiredIdentifiers": "Zorunlu kimlikler",
  "config.field.connect.nameBlacklistPatterns": "Yasak isim kalıpları",
  "config.field.connect.nameBlacklistPatternsHint": "Büyük/küçük harf duyarsız alt dize eşleşmesi.",
  "config.field.connect.globalBans": "Küresel banlar",
  "config.field.connect.banByIp": "IP ile de banla",
  "config.field.connect.banByIpDesc": "Paylaşımlı IP’lerde masum oyuncuları da engelleyebilir.",
  "config.field.connect.minTrustScore": "En düşük güven puanı",
  "config.field.connect.maxSessionsPerIp": "IP başına oturum",
  "config.field.connect.vpnCheck": "VPN/proxy kontrolü",
  "config.field.connect.vpnCheckDesc": "Katılan IP üçüncü taraf bir servise sorulur.",
  "config.field.connect.deferralMessage": "Bekletme mesajı",
  "config.field.connect.messages.banned": "Banlı oyuncu",
  "config.field.connect.messages.globalBanned": "Küresel banlı oyuncu",
  "config.field.connect.messages.unreachable": "Buluta ulaşılamıyor",
  "config.field.connect.messages.missingIdentifiers": "Eksik kimlik",
  "config.field.connect.messages.lowTrust": "Düşük güven puanı",
  "config.field.bypass.staffAce": "Yetkili ACE izni",
  "config.field.bypass.adminAce": "Yönetici ACE izni",
  "config.field.bypass.staffIdentifiers": "Muaf kimlikler",
  "config.field.bypass.staffIdentifiersHint": "license:… · steam:… · discord:…",
  "config.field.safeEvents.enabled": "Etkin",
  "config.field.safeEvents.strict": "Katı mod",
  "config.field.safeEvents.strictDesc": "Geçersiz token’ı kayıttan bana yükseltir.",
  "config.field.safeEvents.tokenTtlMs": "Token ömrü",
  "config.field.screenshots.onBan": "Banda ekran görüntüsü al",
  "config.field.screenshots.onSeverity": "Bu önemden itibaren al",
  "config.field.screenshots.encoding": "Biçim",
  "config.field.screenshots.quality": "Kalite",
  "config.field.screenshots.perPlayerCooldownMs": "Oyuncu başına bekleme",
  "config.field.screenshots.perServerPerMinute": "Dakikada en fazla",
  "config.field.blacklists.weapons": "Yasak silahlar",
  "config.field.blacklists.peds": "Yasak karakterler",
  "config.field.blacklists.vehicles": "Yasak araçlar",
  "config.field.blacklists.objects": "Yasak nesneler",
  "config.field.blacklists.explosionTypes": "Yasak patlama türleri",
  "config.field.blacklists.ptfx": "Yasak efektler",
  "config.field.blacklists.events": "Yasak olaylar",
  "config.field.blacklists.eventStrings": "Yasak olay metinleri",
  "config.field.blacklists.chatStrings": "Yasak sohbet metinleri",
  "config.field.whitelists.resources": "İzinli kaynaklar",
  "config.field.whitelists.entityScripts": "İzinli varlık scriptleri",
  "config.field.whitelists.models": "İzinli modeller",
  "config.field.whitelists.blipSprites": "İzinli blip simgeleri",
  "config.field.whitelists.nightVisionResources": "Gece görüşü kullanabilen kaynaklar",
  "config.field.whitelists.textures": "İzinli dokular",
  "config.field.honeypots.clientEvents": "İstemci bal küpü olayları",
  "config.field.honeypots.clientExports": "İstemci bal küpü export’ları",
  "config.field.honeypots.clientCommands": "İstemci bal küpü komutları",
  "config.field.honeypots.serverEvents": "Sunucu bal küpü olayları",
  "config.field.honeypots.serverExports": "Sunucu bal küpü export’ları",
  "config.field.honeypots.serverCommands": "Sunucu bal küpü komutları",
  "discord.name": "Ad",
  "discord.enabled": "Etkin",
  "discord.created": "Webhook eklendi",
  "discord.updated": "Webhook güncellendi",
  "discord.deleted": "Webhook silindi",
  "discord.deleteTitle": "Webhook’u sil",
  "discord.deleteWarning": "{name} silinecek. Bu işlem geri alınamaz.",
  "discord.emptyDesc": "Tespit, ban ve sunucu durumu bildirimlerini Discord kanalınıza gönderin.",
  "discord.securityTitle": "Webhook adresi güvenliği",
  "discord.eventsRequired": "En az bir olay seçin",
  "discord.failureCount": "{n} başarısız gönderim",
  "discord.lastSuccess": "Son başarılı gönderim",
  "discord.testFailed": "Test başarısız (HTTP {status})",
  "discord.mentionRoleHint": "Discord rol kimliği (yalnızca rakam)",
  "discord.urlHintNew": "Discord kanal ayarlarından webhook adresini kopyalayın.",
  "discord.urlHintEdit": "Boş bırakırsanız kayıtlı adres korunur: {hint}",
  "discord.screenshotSlot": "Ekran görüntüsü eklenir",
  "discord.event.detection": "Tespit",
  "discord.event.ban": "Ban",
  "discord.event.unban": "Ban kaldırma",
  "discord.event.kick": "Atma",
  "discord.event.player_join": "Oyuncu girişi",
  "discord.event.server_status": "Sunucu durumu",
  "discord.event.command_result": "Komut sonucu",
  "discord.event.screenshot_ready": "Ekran görüntüsü hazır",
  "discord.event.global_ban_match": "Küresel ban eşleşmesi",
  "team.member": "Üye",
  "team.permission": "Yetki",
  "team.status": "Durum",
  "team.status.active": "Aktif",
  "team.status.invited": "Davetli",
  "team.emptyMembers": "Henüz üye yok",
  "team.expires": "bitiş",
  "team.resend": "Yeniden gönder",
  "team.revokeInvite": "Daveti iptal et",
  "team.inviteOnce": "Bu bağlantı bir daha gösterilmeyecek",
  "team.inviteOnceDesc": "{email} adresine bu bağlantıyı iletin. Yeniden gönderirseniz eski bağlantı geçersiz olur.",
  "team.cannotChangeSelf": "Kendi rolünüzü değiştiremezsiniz",
  "team.cannotManagePeer": "Kendinizle aynı ya da üstü bir rolü yönetemezsiniz",
  "team.cannotRemoveOwner": "Sahip çıkarılamaz; sahiplik yalnızca devredilebilir",
  "team.cannotRemoveSelf": "Kendinizi çıkaramazsınız",
  "team.alreadyOwner": "Bu üye zaten sahip",
  "team.transferNeedsActive": "Sahiplik yalnızca aktif bir üyeye devredilebilir",
  "team.removeWarning": "{name} bu sunucudan çıkarılacak.",
  "team.transferWarning": "{name} sahip olacak, siz yönetici olacaksınız. Geri almak yalnızca yeni sahibin elinde olur.",
  "team.transferred": "Sahiplik {name} kullanıcısına devredildi",
  "license.emptyTitle": "Aktif lisans yok",
  "license.emptyDesc": "Kaynağın kimlik doğrulaması yapabilmesi için bir anahtar gerekir.",
  "license.issueNew": "Yeni anahtar oluştur",
  "license.noActive": "Aktif lisans yok",
  "license.status.active": "Aktif",
  "license.status.suspended": "Askıda",
  "license.status.revoked": "İptal edildi",
  "license.boundAt": "Bağlanma",
  "license.lastAuthIp": "Son doğrulama IP’si",
  "license.expiresAt": "Bitiş",
  "license.ipResetCount": "IP sıfırlama sayısı",
  "license.bindMode.first_useDesc": "İlk başarılı doğrulamada IP’ye bağlanır.",
  "license.bindMode.manualDesc": "IP’yi siz girersiniz.",
  "license.bindMode.noneDesc": "IP bağlama yapılmaz; yalnızca geliştirme için.",
  "license.bindModeSaved": "Bağlama modu kaydedildi",
  "license.manualIpHint": "Oyun sunucusunun dış IP adresi",
  "license.resetIpWarning": "Bağlı IP silinir ve kaynak bir sonraki doğrulamada yeniden bağlanır. Bugün kalan hak: {n}",
  "license.resetIpDone": "IP sıfırlandı",
  "license.rotateWarning": "Yeni bir anahtar oluşturulur ve bir kez gösterilir. Eski anahtar 24 saat daha çalışır.",
  "license.rotateRevealDesc": "Anahtarı şimdi kopyalayın; kapattıktan sonra bir daha gösterilemez. Kaybederseniz tek çözüm yeniden yenilemektir.",
  "license.graceUntil": "Eski anahtar {time} tarihine kadar geçerli",
  "license.revokeWarning": "Bu anahtar kalıcı olarak iptal edilir; kaynak bir sonraki doğrulamasında korumayı durdurur.",
  "license.revoked": "Lisans iptal edildi",
  "license.revokeLastActive": "Bu son aktif lisans; önce anahtarı yenileyin.",
  "license.supersededTitle": "Eski anahtar hâlâ geçerli ({keyId})",
  "license.supersededDesc": "Yenileme sonrası ek süre bitene kadar iki anahtar da çalışır:",
  "audit.time": "Zaman",
  "audit.ip": "IP",
  "audit.range": "Aralık",
  "audit.range.24h": "24 saat",
  "audit.range.7d": "7 gün",
  "audit.range.30d": "30 gün",
  "audit.range.all": "Tümü",
  "audit.actorTypeCol": "İşleyen türü",
  "audit.actorType.user": "Kullanıcı",
  "audit.actorType.api_key": "API anahtarı",
  "audit.actorType.agent": "Kaynak",
  "audit.actorType.system": "Sistem",
  "audit.targetType": "Hedef türü",
  "audit.allInGroup": "{prefix}.* — tümü",
  "audit.emptyDesc": "Bu sunucuda henüz denetime konu bir işlem yapılmadı.",
  "audit.noPayload": "Bu kayıt için ayrıntı yok",
  "audit.exportTooWide": "Aralık çok geniş; daraltıp tekrar deneyin.",
  "settings.saved": "Ayarlar kaydedildi",
  "settings.noChanges": "Değişiklik yok",
  "settings.frameworkNote": "Framework değişikliği config.general.framework alanını da günceller ve yeni bir yapılandırma sürümü oluşturur.",
  "settings.timezoneNote": "Tarihler bu saat diliminde gösterilir.",
  "settings.contributeNote": "Kesinleşmiş banlarınız küresel listeye öneri olarak gönderilir.",
  "settings.globalBansMode": "Küresel ban modu",
  "settings.changeInConfig": "Yapılandırmadan değiştirin",
  "settings.detectionsRetentionDays": "Tespit saklama süresi",
  "settings.screenshotsRetentionDays": "Ekran görüntüsü saklama süresi",
  "settings.installNote": "Anahtar burada maskeli gösterilir; tam anahtar yalnızca yenilendiğinde bir kez görünür.",
  "settings.deleted": "{name} silindi",

  // ── staff pages: dashboard, live, detections, players, lookup ──
  "dashboard.activeBans": "Aktif ban: {n}",
  "dashboard.agentIp": "Kaynak IP",
  "dashboard.agentVersion": "Kaynak sürümü",
  "dashboard.banListVersion": "Ban listesi sürümü",
  "dashboard.configVersion": "Yapılandırma",
  "dashboard.lastHeartbeat": "Son sinyal",
  "dashboard.peakPlayers": "Zirve {n} oyuncu",
  "dashboard.resourceCount": "Kaynak sayısı",
  "dashboard.trendHint": "Seçili aralıktaki eğilim",
  "detection.action": "İşlem",
  "detection.batchId": "Toplu iş kimliği",
  "detection.bulkDone": "{updated} güncellendi, {skipped} atlandı",
  "detection.bulkLimit": "Tek seferde en fazla {n} kayıt incelenebilir",
  "detection.clockSkew": "Saat farkı",
  "detection.eventId": "Olay kimliği",
  "detection.falsePositive": "Yanlış pozitif",
  "detection.key": "Modül",
  "detection.markResolved": "Çözüldü işaretle",
  "detection.notExecuted": "İşlem uygulanamadı",
  "detection.otherModules": "Diğer ({n})",
  "detection.player": "Oyuncu",
  "detection.rangeToday": "Bugün",
  "detection.resolved": "Çözüldü",
  "detection.reviewSaved": "İnceleme kaydedildi",
  "detection.reviewed": "İnceleme",
  "detection.reviewedAtHint": "Bu kayıt daha önce incelendi",
  "detection.searchPlaceholder": "Oyuncu adı veya kimlik",
  "detection.selectedCount": "{n} kayıt seçildi",
  "detection.severity": "Önem",
  "detection.side": "Taraf",
  "detection.total": "Toplam",
  "filter.dateRange": "Tarih aralığı",
  "player.actions": "İşlemler",
  "player.bans": "Ban",
  "player.detailTitle": "Oyuncu detayı",
  "player.detections": "Tespit",
  "player.identifiers": "Kimlikler",
  "player.lastSource": "Sunucu kimliği",
  "player.lookupHelp": "Bir kimlik yapıştırın; üyesi olduğunuz tüm sunucularda aranır",
  "player.lookupInvalid": "Bu kimlik tanınmadı",
  "player.lookupRetryIn": "{n} saniye sonra tekrar deneyin",
  "player.name": "Oyuncu",
  "player.noOtherServers": "Başka sunucuda görülmedi",
  "player.noSessions": "Oturum kaydı yok",
  "player.notConnected": "Oyuncu şu anda bağlı değil",
  "player.notesAutosave": "Yazmayı bıraktığınızda otomatik kaydedilir",
  "player.searchPlaceholder": "Ad veya kimlik",
  "player.sessionOngoing": "Devam ediyor",
  "player.sort": "Sıralama",
  "player.whitelisted": "Beyaz listede",
  "screenshot.bytes": "Boyut",
  "screenshot.expiresAt": "Silinme",
  "screenshot.sha256": "SHA-256",
  // ── marketing: the public landing and pricing pages ──
  "marketing.nav": "Ana gezinme",
  "marketing.nav.features": "Özellikler",
  "marketing.nav.how": "Nasıl çalışır",
  "marketing.nav.pricing": "Fiyatlandırma",
  "marketing.nav.faq": "SSS",
  "marketing.cta.start": "Ücretsiz başla",
  "marketing.cta.panel": "Panele git",
  "marketing.hero.badge": "FiveM için bulut yönetimli anticheat",
  "marketing.hero.title": "Sunucunuzu koruyun, kanıtı görün, kimseyi haksız yere banlamayın",
  "marketing.hero.lead": "SentinelAC tek panelden yönetilen bir FiveM anticheat'idir. Korunan her resource'un kendi Lua durumu içinde çalışır, her tespiti kanıtıyla saklar ve sunucunun doğrulayamadığı bir iddia için asla ban atmaz.",
  "marketing.hero.note": "Kurulum server.cfg'ye altı satır. Kredi kartı istenmez.",
  "marketing.stat.modules": "tespit modülü",
  "marketing.stat.sides": "istemci · sunucu · bulut",
  "marketing.stat.sidesValue": "3 katman",
  "marketing.stat.latency": "canlı akış gecikmesi",
  "marketing.stat.latencyValue": "< 1 sn",
  "marketing.stat.lang": "panel dili",
  "marketing.stat.langValue": "TR / EN",
  "marketing.features.eyebrow": "Ne yapar",
  "marketing.features.title": "Bir anticheat'ten beklediğiniz her şey, artı kanıt",
  "marketing.features.lead": "Her modülün kendi işlemi, uyarı eşiği, penceresi ve kanıt zarfı var. Hiçbiri “aç ve dua et” değil.",
  "marketing.feature.modules.title": "Katmanlı tespit",
  "marketing.feature.modules.body": "Tanrı modu, noclip, ışınlanma, silah, araç, patlama, entity spam ve daha fazlası — istemci, sunucu ve bulut tarafında.",
  "marketing.feature.combat.title": "Savaş katmanı",
  "marketing.feature.combat.body": "Sessiz nişan, geri tepmesiz atış, atış hızı, sihirli mermi ve sunucu taraflı kafa vuruşu dağılımı.",
  "marketing.feature.map.title": "Canlı harita",
  "marketing.feature.map.body": "Oyuncuların nerede olduğunu anlık görün. Tespit gelen oyuncu haritada işaretlenir, tıklayın ve dosyasına gidin.",
  "marketing.feature.rules.title": "Event kuralları",
  "marketing.feature.rules.body": "Kendi net eventleriniz üzerine kural yazın: isim eşleşmesi, argüman koşulu, oyuncu başına hız limiti.",
  "marketing.feature.global.title": "Küresel ban ağı",
  "marketing.feature.global.body": "Kesinleşmiş banlar diğer sunuculara önerilir. Öneren sunucunun itibar puanı var, yani liste kirlenmez.",
  "marketing.feature.evidence.title": "Kanıt ve ekran görüntüsü",
  "marketing.feature.evidence.body": "Her tespit örneklem, strike sayısı ve isteğe bağlı ekran görüntüsüyle gelir. İtiraz gelirse elinizde bir şey olur.",
  "marketing.feature.discord.title": "Discord entegrasyonu",
  "marketing.feature.discord.body": "Kategori başına webhook: bağlantılar, banlar, tespitler, ekran görüntüleri.",
  "marketing.feature.frameworks.title": "Framework uyumu",
  "marketing.feature.frameworks.body": "ESX, QBCore, Qbox ve bağımsız sunucular. Envanter kontrolleri framework'ünüze sorar.",
  "marketing.how.eyebrow": "Kurulum",
  "marketing.how.title": "Üç adım, on dakika",
  "marketing.how.lead": "Kaynağı indirin, server.cfg'ye satırları ekleyin, paneli açın.",
  "marketing.how.cfgLabel": "server.cfg",
  "marketing.step.install.title": "Kur",
  "marketing.step.install.body": "Kaynağı panelden indirin, resources klasörüne çıkarın, lisans anahtarınızı server.cfg'ye yazın.",
  "marketing.step.watch.title": "İzle",
  "marketing.step.watch.body": "İlk gün “yalnızca kayıt” modunda kalın. Hiçbir oyuncu atılmaz; ne yakalandığını canlı akışta görürsünüz.",
  "marketing.step.promote.title": "Yükselt",
  "marketing.step.promote.body": "Kendi sunucunuzda neyin normal olduğunu gördükten sonra modülleri tek tek `at` ve `banla` seviyesine çekin.",
  "marketing.honesty.title": "Söylemediğimiz şeyler",
  "marketing.honesty.body1": "Harici aimbot — Eulen, RedEngine ve benzerleri — oyun betiklerinin dışında bir DirectX kancasıyla çalışır. Hiçbir Lua native'i onu göremez. Bunu biz de göremeyiz, rakiplerimiz de göremez. “Aimbot tespiti” diye satılan her şey, bizimki dahil, bir davranış sezgisidir.",
  "marketing.honesty.body2": "Bu yüzden savaş modüllerimiz hilenin kendisini değil, insanın üretemeyeceği sonucunu ölçer: nişan alınmayan yere isabet eden mermi, silahın kaldıramayacağı atış hızı, kimsenin sürdüremeyeceği kafa vuruşu dağılımı. Ve bu yüzden hiçbiri küresel ban önerisi üretemez.",
  "marketing.honesty.body3": "Sunucunun doğrulayabildiği bir iddia doğrulanmadıysa ban, ata düşer. İstatistiksel modüller varsayılan olarak yalnızca kayıt tutar. Bir eşiği ölçmeden cezaya çevirmenizi istemiyoruz.",
  "marketing.pricing.eyebrow": "Fiyatlandırma",
  "marketing.pricing.title": "Sunucu sayınıza göre, sürprizsiz",
  "marketing.pricing.lead": "Tespit kataloğunun tamamı her planda var. Planlar sunucu sayısı, saklama süresi ve ekip büyüklüğü üzerinden ayrılır.",
  "marketing.plan.popular": "En çok seçilen",
  "marketing.plan.free": "Ücretsiz",
  "marketing.plan.custom": "Görüşelim",
  "marketing.plan.perMonth": "/ay",
  "marketing.plan.contact": "İletişime geç",
  "marketing.plan.starter.name": "Başlangıç",
  "marketing.plan.starter.for": "Tek sunuculu, yeni açılan topluluklar için.",
  "marketing.plan.pro.name": "Pro",
  "marketing.plan.pro.for": "Oyuncu sayısı olan, ekiple yönetilen sunucular için.",
  "marketing.plan.enterprise.name": "Kurumsal",
  "marketing.plan.enterprise.for": "Sunucu ağı işleten ve SLA isteyen ekipler için.",
  "marketing.limit.unlimited": "Sınırsız",
  "marketing.limit.servers": "{n} sunucu",
  "marketing.limit.retention": "{n} gün kayıt saklama",
  "marketing.limit.seats": "{n} ekip üyesi",
  "marketing.limit.days": "{n} gün",
  "marketing.limit.screenshots": "Tespit anında ekran görüntüsü",
  "marketing.limit.liveMap": "Canlı oyuncu haritası",
  "marketing.limit.eventRules": "Event kuralları",
  "marketing.limit.globalBans": "Küresel ban ağı",
  "marketing.limit.discord": "Discord webhook'ları",
  "marketing.limit.apiKeys": "REST API anahtarları",
  "marketing.compare.title": "Planları karşılaştırın",
  "marketing.compare.feature": "Özellik",
  "marketing.compare.row.servers": "Sunucu",
  "marketing.compare.row.retentionDays": "Kayıt saklama",
  "marketing.compare.row.seats": "Ekip üyesi",
  "marketing.compare.row.modules": "Tespit kataloğunun tamamı",
  "marketing.compare.row.logOnly": "Yalnızca kayıt modu",
  "marketing.compare.row.serverConfirm": "Sunucu doğrulaması olmadan ban yok",
  "marketing.compare.row.screenshots": "Ekran görüntüsü",
  "marketing.compare.row.liveMap": "Canlı harita",
  "marketing.compare.row.eventRules": "Event kuralları",
  "marketing.compare.row.globalBans": "Küresel ban ağı",
  "marketing.compare.row.discord": "Discord webhook'ları",
  "marketing.compare.row.apiKeys": "API anahtarları",
  "marketing.compare.row.support": "Destek",
  "marketing.support.starter": "Topluluk",
  "marketing.support.pro": "Öncelikli",
  "marketing.support.enterprise": "Özel kanal + SLA",
  "marketing.billing.title": "Ödeme ve abonelik",
  "marketing.billing.trial.q": "Denemek için ödeme yapmam gerekiyor mu?",
  "marketing.billing.trial.a": "Hayır. Başlangıç planı süresiz ücretsizdir ve tespit kataloğunun tamamını içerir; sınırlar sunucu sayısı, saklama süresi ve ekip büyüklüğündedir.",
  "marketing.billing.change.q": "Plan değiştirebilir miyim?",
  "marketing.billing.change.a": "Evet, panelden istediğiniz zaman. Yükseltme anında geçerli olur; düşürme, mevcut dönemin sonunda.",
  "marketing.billing.cancel.q": "İptal edersem verilerim ne olur?",
  "marketing.billing.cancel.a": "Hesabınız Başlangıç planına düşer ve saklama süresi o planın süresine iner. Banlarınız ve sunucu yapılandırmanız durur; silinmez.",
  "marketing.billing.invoice.q": "Fatura alabilir miyim?",
  "marketing.billing.invoice.a": "Evet. Her ödeme için fatura panelin Plan sayfasından indirilebilir.",
  "marketing.billing.currency.q": "Neden euro?",
  "marketing.billing.currency.a": "FiveM barındırma ve eklenti pazarı euro üzerinden çalışıyor, karşılaştırma kolay olsun diye biz de öyle yapıyoruz.",
  "marketing.contact.title": "Emin olamadınız mı?",
  "marketing.contact.body": "Sunucunuzu anlatın, hangi planın yeteceğini birlikte bakalım. Kurumsal planda özel modül ve SLA konuşulabilir.",
  "marketing.faq.eyebrow": "Sık sorulanlar",
  "marketing.faq.title": "Kurmadan önce merak edilenler",
  "marketing.faq.aimbot.q": "Aimbot'u gerçekten yakalıyor mu?",
  "marketing.faq.aimbot.a": "Harici aimbot Lua ile görülemez — bu bizim değil, platformun sınırı. Yakaladığımız şey sonucu: nişan alınmayan yere giden mermi, mekanik sınırın üstünde atış hızı, geri tepmesiz atış serisi ve sunucu tarafında kafa vuruşu dağılımı. Bu sinyaller varsayılan olarak ban değil, at ve kayıt üretir.",
  "marketing.faq.performance.q": "Sunucumu yavaşlatır mı?",
  "marketing.faq.performance.a": "İstemcide tek bir zamanlayıcı thread'i var; modüller kendi periyotlarında çalışır ve boştaki maliyet kare başına ölçülemeyecek kadar küçüktür. Kare başına iş yapan modüller yalnızca oyuncu ateş ederken uyanır.",
  "marketing.faq.falsePositives.q": "Yanlış pozitif olursa?",
  "marketing.faq.falsePositives.a": "İlk gün yalnızca kayıt modunda kalmanızı öneriyoruz. Her modülün uyarı eşiği ve penceresi ayarlanabilir, her modül için beyaz liste ve muafiyet export'u var, ve sunucunun doğrulayamadığı iddia bana dönüşemez.",
  "marketing.faq.offline.q": "Bulut erişilemezse ne olur?",
  "marketing.faq.offline.a": "Kaynak son doğrulanmış yapılandırmayı ve ban listesini diskte tutar. Bağlantı yokken oyuncuların girmesine izin verme davranışını siz seçersiniz: önbellek, izin ver veya reddet.",
  "marketing.faq.selfHost.q": "Kendi sunucumda barındırabilir miyim?",
  "marketing.faq.selfHost.a": "Kurumsal planda evet. Kurulum betiği paylaşımlı bir makineye, oradaki diğer siteleri bozmadan kurulacak şekilde yazıldı.",
  "marketing.faq.data.q": "Hangi verileri saklıyorsunuz?",
  "marketing.faq.data.a": "Oyuncu kimlikleri, tespit kanıtları ve isteğe bağlı ekran görüntüleri. IP adresleri günlüklerde gizlenebilir. Saklama süresi planınıza göre saatlik temizlik işiyle uygulanır.",
  "marketing.final.title": "Bu gece kurun, sabah ne yakaladığına bakın",
  "marketing.final.body": "Yalnızca kayıt modunda başlayın. Hiçbir oyuncunuz etkilenmez; siz sadece sunucunuzda gerçekte ne olduğunu görürsünüz.",
  "marketing.footer.tagline": "FiveM sunucuları için bulut yönetimli anticheat.",

  // ── the live map ──
  "nav.map": "Canlı Harita",
  "map.title": "Canlı harita",
  "map.live": "Canlı",
  "map.stale": "Veri gelmiyor",
  "map.online": "{n} oyuncu",
  "map.reset": "Görünümü sıfırla",
  "map.roster": "Oyuncular",
  "map.emptyTitle": "Kimse yok",
  "map.emptyBody": "Sunucu çevrimdışıysa veya canlı harita kapalıysa burası boş kalır.",
  "map.privacy": "Konumlar hiçbir yerde saklanmaz: sunucudan gelir, bu sayfada gösterilir ve unutulur. Haritayı Yapılandırma > Genel bölümünden tamamen kapatabilirsiniz.",

  "config.sectionLiveMap": "Canlı harita",
  "config.sectionLiveMapDesc": "Oyuncu konumları sunucudan alınır, panele iletilir ve hiçbir yerde saklanmaz. Kapatmak trafiği tamamen durdurur.",
  "config.field.liveMap.enabled": "Canlı haritayı aç",
  "config.field.liveMap.enabledDesc": "Kapalıyken sunucu konum göndermez; harita sayfası boş kalır.",
  "config.field.liveMap.intervalMs": "Gönderim aralığı (ms)",
  "config.field.liveMap.intervalMsDesc": "Kısaltmak haritayı akıcılaştırır, sunucu ve bant genişliği maliyetini artırır.",

  // ── the customer plan page ──
  "nav.plan": "Plan",
  "plan.title": "Planınız",
  "plan.current": "Mevcut plan",
  "plan.usageTitle": "Kullanım",
  "plan.usageDesc": "Ölçülebilen limitler burada. Ölçemediğimiz bir şeye çubuk çizmiyoruz.",
  "plan.includedTitle": "Planınıza dahil",
  "plan.changeTitle": "Plan değiştir",
  "plan.changeDesc": "Sunucu sayınız veya ekibiniz büyüdüyse üst plana geçebilirsiniz.",
  "plan.contactNote": "Ödeme sağlayıcısı henüz bağlı değil, bu yüzden plan değişikliği şimdilik bizimle konuşularak yapılıyor. Yarım bir ödeme formu koymaktansa bunu söylemeyi tercih ettik.",
  "plan.comparePlans": "Planları karşılaştır",

  "map.tilt": "3B görünüm",
  "map.flat": "Düz görünüm",
  "map.legend.onFoot": "Yaya",
  "map.legend.inVehicle": "Araçta",
  "map.legend.hurt": "Yaralı",
  "map.legend.down": "Yerde",
  "config.field.liveMap.imageUrl": "Harita görseli (isteğe bağlı)",
  "config.field.liveMap.imageUrlDesc": "Boş bırakılırsa panelin kendi çizdiği San Andreas haritası kullanılır. Kullanma hakkına sahip olduğunuz bir harita görselinin https adresini verirseniz oyuncu noktaları onun üzerine çizilir.",

  "marketing.mock.feed": "Canlı akış",
  "marketing.mock.module": "Modül ayarı",
  "marketing.mock.map": "Canlı harita",
  "marketing.mock.strikes": "uyarı",

  "marketing.proof.tuning.eyebrow": "Ayarlanabilirlik",
  "marketing.proof.tuning.title": "Her modülün kendi işlemi, eşiği ve penceresi var",
  "marketing.proof.tuning.body": "Bir modülü açıp kaderine bırakmıyorsunuz. Ne yapacağını (kayıt, at, banla), kaç örneklemde tetikleneceğini, hangi süre penceresinde sayacağını ve ekran görüntüsü isteyip istemediğini tek tek siz seçiyorsunuz. Beyaz liste ve muafiyet export'u da modül başına.",
  "marketing.proof.map.eyebrow": "Canlı harita",
  "marketing.proof.map.title": "Kimin nerede olduğunu anlık görün",
  "marketing.proof.map.body": "Oyuncular haritada canlı hareket eder; yaya, araçta, yaralı ve yerde olanlar ayrı renktedir. Listeden birine tıklayın, harita ona odaklansın. Konumlar hiçbir yerde saklanmaz — sunucudan gelir, gösterilir ve unutulur.",
  "marketing.honesty.eyebrow": "Dürüstlük",
  "marketing.honesty.cannotTitle": "Yapamadığımız şeyler",
  "marketing.honesty.canTitle": "Bunun yerine ölçtüklerimiz",
  "marketing.honesty.cannot.external": "Harici aimbot ve ESP'yi göremeyiz. Oyun betiklerinin dışında, bir DirectX kancasıyla çizilirler; hiçbir Lua native'i onlara erişemez.",
  "marketing.honesty.cannot.memory": "Bellek üzerinden yapılan noclip gibi, hiçbir native çağırmayan hileleri doğrudan göremeyiz.",
  "marketing.honesty.cannot.certainty": "Davranış sezgilerinden kesinlik üretemeyiz. Bu yüzden savaş modüllerinin hiçbiri küresel ban önerisi üretmez.",
  "marketing.honesty.can.divergence": "Merminin, kameranın baktığı eksenden saparak isabet etmesi — sessiz nişanın Lua'dan görülebilen tek izi.",
  "marketing.honesty.can.cadence": "Silahın mekanik atış aralığından hızlı ateş ve geri tepmesiz atış serileri. Bunların beceri tarafı yoktur.",
  "marketing.honesty.can.distribution": "Sunucu tarafında kafa vuruşu dağılımı: yeterli örneklemde kimsenin sürdüremeyeceği bir oran.",
  "marketing.honesty.can.server": "Sunucunun kendi doğrulayabildiği her şey — hasar olayları, konum, ölümsüzlük — istemci ne derse desin.",

  "map.online.one": "1 oyuncu",
  "map.online.other": "{n} oyuncu",
  "map.lastSeen": "{s} sn önce {n} oyuncu",

  "map.connecting": "Bağlanıyor",

  "plan.notMeasured": "Bu, planınızın üst sınırı — şu anki kullanımınız değil. Ekip üyesi sayısını henüz ölçmüyoruz.",

  "map.image.title": "Gerçek GTA haritasını kullanın",
  "map.image.body": "Panel kendi çizdiği San Andreas haritasını gösteriyor. Kullanma hakkına sahip olduğunuz bir GTA harita görselinin adresini verirseniz oyuncu noktaları onun üstüne çizilir.",
  "map.image.hint": "https ile başlamalı. Görselin kapladığı dünya alanı Yapılandırma > Genel bölümünden ayarlanabilir; varsayılan değerler standart FiveM minimap dışa aktarımıyla uyumludur.",
  "map.image.saved": "Harita görseli kaydedildi",
  "map.image.failed": "Harita görseli kaydedilemedi",

}
